"use strict";

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

/**
 * axboot 오브젝트 axboot 애플리케이션을 편리하게 사용하기 위한 오브젝트 입니다.
 * @var {Object} axboot
 */
var axboot = {};

/**
 * axboot의 환경 변수 저장 공간
 * @type {Object} axboot.def
 * @example
 * ```js
 * axboot.def.menuHeight = 20;
 * // 와 같이 원하는 속성을 저장 / 사용 할 수 있다.
 * ```
 */
axboot.def = {
    'pageFunctionName': 'fnObj',
    'iframeLoadingMsg': '<i class="cqc-chequer ax-loading-icon lg"></i>',
    'dialogTitle': 'Info',
    'defaultPageSize': 25,
    'dateMonthFormat': 'YYYY.MM',
    'dateFormat': 'YYYY.MM.DD',
    'dateTimeFormat': 'YYYY.MM.DD HH:mm:ss',
    'uploader': {
        'storageUrl': '/common/file/Storage.do',
        'uploadUrl': '/common/file/UploadFile.do',
        'fileListUrl': '/common/file/UploadFileList.do',
        'deleteUrl': '/common/file/UploadFileDelete.do'
    }
};

/**
 * document ready 상태가 되었을 때 실행됩니다. 애플리케이션 초기화를 담당합니다.
 * @method axboot.init
 */
axboot.init = function () {
    axboot.pageAutoHeight.init();
    axboot.pageAutoHeight.align();

    setTimeout(function () {
        $('[data-ax5layout]').ax5layout({
            splitter: {
                size: 6
            },
            autoResize: false,
            onStateChanged: function onStateChanged() {},
            onResize: function onResize() {
                axboot.layoutResize();
            }
        }); // 레이아웃 플러그인 실행

        axboot.pageStart();

        var debounceFn = ax5.util.debounce(function (val) {
            axboot.pageResize();
            axboot.pageAutoHeight.align();
            $('[data-ax5layout]').ax5layout('reset');
        }, 20);

        $(window).resize(function () {
            debounceFn();
        });
        $(document.body).on('click', function () {
            if (window.parent != window) {
                $(parent.document.body).trigger("click");
            }
        });
    });
};

/**
 * axboot.def.pageFunctionName의 pageStart를 실행해 줍니다.
 * @method axboot.pageStart
 *
 */
axboot.pageStart = function () {
    if (window[axboot.def.pageFunctionName] && window[axboot.def.pageFunctionName].pageStart) {
        // 프레임 셋에 타이머 초기화.
        if (top.fnObj && top.fnObj.activityTimerView) {
            top.fnObj.activityTimerView.update();
        }
        window[axboot.def.pageFunctionName].pageStart();
    }
};
/**
 * axboot.def.pageFunctionName의 pageResize를 실행해 줍니다.
 * @method axboot.pageResize
 */
axboot.pageResize = function () {
    if (window[axboot.def.pageFunctionName] && window[axboot.def.pageFunctionName].pageResize) {
        window[axboot.def.pageFunctionName].pageResize();
    }
};

/**
 * 페이지내부에 선언된 ax5layout안에 UI들에 강제 resize이벤트 발생시켜 줌.
 * @method axboot.layoutResize
 */
axboot.layoutResize = function (_delay) {

    $('[data-fit-height-content]').each(function () {
        var $this = $(this);
        var _pHeight = $this.offsetParent().height();
        var name = this.getAttribute("data-fit-height-content");

        var _tabHeight = 0;

        // 20180514 (이상훈) : split-layout > tab layout 이 있을 경우 문제 해결 후 주석해제
        /*
        if (!ax5.util.isNothing($this.data('config'))) {
            var objConfig = ax5.util.parseJson($this.data('config'));
             if (!ax5.util.isNothing(objConfig) && objConfig['layout'] == 'tab-panel') {
                _tabHeight = 60;
            }
        }
        */

        var _asideHeight = 0;
        $('[data-fit-height-aside="' + name + '"]').each(function () {
            _asideHeight += $(this).outerHeight();
        });
        $this.css({ height: _pHeight - _asideHeight - _tabHeight });
    });

    $('[data-fix-height-content]').each(function () {
        var $this = $(this);
        var _pHeight = this.getAttribute("height");
        $this.css({ height: _pHeight });
    });

    function fn() {
        if (ax5.ui.grid_instance) {
            var gi = ax5.ui.grid_instance.length;
            while (gi--) {
                ax5.ui.grid_instance[gi].setHeight(ax5.ui.grid_instance[gi].$target.height());
            }
        }
        if (ax5.ui.mask_instance) {
            var mi = ax5.ui.mask_instance.length;
            while (mi--) {
                ax5.ui.mask_instance[mi].align();
            }
        }
        if (ax5.ui.autocomplete_instance) {
            ax5.ui.autocomplete_instance.align();
        }
        if (ax5.ui.combobox_instance) {
            ax5.ui.combobox_instance.align();
        }
    }
    if (_delay) {
        setTimeout(function () {
            fn();
        }, _delay);
    } else {
        fn();
    }
};

/**
 * 페이지안에 [role="page-content"] 과 그 외의 부분의 높이를 계산하여 페이지 안에 컨텐츠의 높이들을 꽉 차게 해줍니다.
 * @Object {Object} axboot.pageAutoHeight
 */
axboot.pageAutoHeight = {
    /**
     * @method axboot.pageAutoHeight.init
     */
    init: function init() {
        this.active = $(document.body).attr("data-page-auto-height");
    },
    /**
     * @method axboot.pageAutoHeight.align
     */
    align: function align() {
        if (!this.active) return false;
        // page-content-auto-height
        (function () {
            var winHeight = $(window).height();
            var minusHeight = 0;
            $('[role^="page-"]').each(function () {
                var sectionName = this.getAttribute("role");
                if (sectionName != "page-content") {
                    minusHeight += $(this).outerHeight();
                }
            });
            var contentHeight = winHeight - minusHeight - 10;
            $('[role="page-content"]').css({ height: contentHeight });
        })();
    }
};

///// ~~~~~~~~~~~~~~~~~~~~~~
$(document.body).ready(function () {
    axboot.preparePlugin.pageStart();
    axboot.init();

    document.createElement("lang");
});

window.onError = function () {
    window.CollectGarbage && window.CollectGarbage();
};

window.onUnload = function () {
    window.CollectGarbage && window.CollectGarbage();
};

/**
 * @method axboot.ajax
 * @param {Object} http
 * @param {String} http.type
 * @param {String} http.url
 * @param {Object|String} http.data
 * @param {Function} http.callback
 * @param {Object} [http.options]
 * @param {Boolean} [http.options.nomask = false]
 * @param {Function} [http.options.onError]
 * @param {String} [http.options.contentType]
 * @param {String} [http.options.apiType]
 * @example
 * ```js
 *  // 기본 에러가 나면 알어서 처리 함.
 *  axboot.ajax({
 *      type: "GET",
 *      url: "/api/v1/users",
 *      data : {},
 *      callback: function(response){
 *          // do something
 *      }
 *  });
 *
 *  // onError 지정
 *  axboot.ajax({
 *      type: "GET",
 *      url: "/api/v1/users",
 *      data : {},
 *      callback: function(response){
 *          // do something
 *      },
 *      options: {
 *          onError: function(err){
 *              // console.log(err);
 *          }
 *      }
 *  });
 * ```
 */
axboot.ajax = function () {
    var queue = [];
    var defaultOption = {
        type: 'POST',
        contentType: 'application/json; charset=UTF-8'
    };

    return function (http) {
        var jqxhr, httpOpts, callback, unconditionalCallback;
        var options = $.extend(true, {}, defaultOption, http.options);
        if (!options.nomask) axAJAXMask.open();

        queue.push('1');

        httpOpts = {
            type: options.type,
            contentType: options.contentType,
            url: http.url,
            unconditionalCallback: http.unconditionalCallback
        };

        $.extend(http, httpOpts);

        callback = http.callback;
        unconditionalCallback = http.unconditionalCallback;

        jqxhr = $.ajax(http);
        jqxhr.done(function (data, textStatus, jqXHR) {
            var executeUserFunc = true;
            var responseType = axboot.util.getResponseType(data);

            if (responseType == 'validation' && data.errorCount > 0) {
                executeUserFunc = false;
            }

            axboot.util.responseResultMsg(data);

            if (data['loginRequired'] && data['redirect']) {
                axDialog.alert({
                    theme: 'danger',
                    title: '인증오류 !',
                    msg: '로그인이 필요합니다. 로그인 페이지로 이동합니다.',
                    width: 500
                }, function () {
                    if (top.loginPage && ax5.util.isFunction(top.loginPage)) {
                        top.loginPage(data['redirectUrl']);
                    } else {
                        top.location.href = data['redirectUrl'];
                    }
                });

                return;
            }

            if (executeUserFunc || unconditionalCallback) {
                var args = [].concat($.makeArray(arguments));
                if (callback) callback.apply(this, args); // callback
            }
        }).fail(function (jqXHR, textStatus, errorThrown) {
            if (jqXHR.status === 0) {
                //console.log('# jqXHR.status : Not connect. Verify Network.' + errorThrown);
                //alert('Not connect. Verify Network.');
            } else if (jqXHR.status == 500) {
                axboot.util.responseResultMsg(jqXHR.responseJSON);
            } else if (jqXHR.status == 400 || jqXHR.status == 403 || jqXHR.status == 404
            //|| jqXHR.status == 500
            || jqXHR.status == 503) {
                alert('[' + jqXHR.status + '] - ' + errorThrown);
            } else if (errorThrown === 'parsererror') {
                alert('Requested JSON parse failed.');
            } else if (errorThrown === 'timeout') {
                alert('Time out error.');
            } else if (errorThrown === 'abort') {
                alert('Ajax request aborted.');
            } else {
                alert('[' + jqXHR.status + '] - ' + 'Uncaught Error -> (' + errorThrown + ')\n지속적으로 오류발생시 새로고침을 해보세요.');
                //location.reload(true);
            }

            /*
            if (errorThrown == "") {} else {
                if (callback) callback.apply(this, [{
                    error: { message: msg }
                }]); // callback
            }
            */

            if (!options.nomask) axAJAXMask.close(300);
        }).always(function (data, textStatus, jqXHR) {
            queue.pop();

            // 프레임 셋에 타이머 초기화.
            if (top.fnObj && top.fnObj.activityTimerView) {
                top.fnObj.activityTimerView.update();
            }

            if (!options.nomask) if (queue.length == 0) axAJAXMask.close(300);
        });
    };
}();

/**
 * @method axboot.buttonClick
 * @param {Object} _caller - this of function
 * @param {String} _attribute
 * @param {Object} _functionJson - 속성명과 매치되는 함수 속성값을 가진 버튼을 클릭하면 속성키에 선언된 함수가 실행됩니다.
 * @return _caller
 * @example
 * ```js
 * axboot.buttonClick(this, "data-page-btn", {
 *  "SEARCH": function(){
 *      ACTIONS.dispatch(ACTIONS.PAGE_SEARCH);
 *  }
 * });
 * ```
 */

axboot.buttonClick = function () {
    return function (_caller, _attribute, _functionJson) {
        var processor = $.extend(true, {}, _functionJson);

        $('[' + _attribute + ']').click(function () {
            var act = this.getAttribute(_attribute);

            if (act in processor) {
                processor[act].call(_caller, act, this);
            } else {
                ACTIONS.dispatch(ACTIONS[act]);
            }
        });

        return this;
    };
}();
/**
 * @Object {Object} axboot.call
*/

/**
 * 여러개의 AJAX콜을 순차적으로 해야 하는 경우 callback 지옥에 빠지기 쉽다. `axboot.call & done`은 이런 상황에서 코드가 보기 어려워지는 문제를 해결 하기 위해 개발된 오브젝트 입니다
 * @method axboot.call
 * @example
 * ```js
 *   axboot
 *       .call({
 *           type: "GET", url: "/api/v1/programs", data: "",
 *           callback: function (res) {
 *               var programList = [];
 *               res.list.forEach(function (n) {
 *                   programList.push({
 *                       value: n.progCd, text: n.progNm + "(" + n.progCd + ")",
 *                       progCd: n.progCd, progNm: n.progNm,
 *                       data: n
 *                   });
 *               });
 *               this.programList = programList;
 *           }
 *       })
 *       .call(function () {
 *           this.something = 1;
 *       })
 *       .call({
 *           type: "GET", url: "/api/v1/commonCodes", data: {groupCd: "AUTH_GROUP", useYn: "Y"},
 *           callback: function (res) {
 *               var authGroup = [];
 *               res.list.forEach(function (n) {
 *                   authGroup.push({
 *                       value: n.code, text: n.name + "(" + n.code + ")",
 *                       grpAuthCd: n.code, grpAuthNm: n.name,
 *                       data: n
 *                   });
 *               });
 *               this.authGroup = authGroup;
 *           }
 *       })
 *       .done(function () {
 *           CODE = this; // this는 call을 통해 수집된 데이터들.
 *
 *           _this.pageButtonView.initView();
 *           _this.searchView.initView();
 *           _this.treeView01.initView();
 *           _this.formView01.initView();
 *           _this.gridView01.initView();
 *
 *           ACTIONS.dispatch(ACTIONS.PAGE_SEARCH);
 *       });
 * ```
 */

/**
 * axboot.call 참조
 * @method axboot.call.done
 */
axboot.call = function () {

    var callClass = function callClass(_obj) {
        this.queue = [];

        var self = this;
        var processor = function processor(callback) {
            var item = self.queue.shift();
            if (ax5.util.isFunction(item)) {
                item.call(this);
                processor.call(this, callback);
            } else if (item) {
                axboot.ajax({
                    type: item.type,
                    url: item.url,
                    data: item.data,
                    callback: function (res) {
                        item.callback.call(this, res);
                        processor.call(this, callback);
                    }.bind(this),
                    options: { nomask: false }
                });
            } else {
                callback.call(this);
            }
        };

        this.call = function (_obj) {
            this.queue.push(_obj);
            return this;
        };
        this.done = function (callback) {
            processor.call({}, callback);
        };
        this.call(_obj);
    };

    return function (obj) {
        return new callClass(obj);
    };
}();

/**
 * @Class axboot.lang
 *
 * @method axboot.lang.get
 * @param {String} _message
 * @param {*} [args]
 * @return {String}
 */
axboot.lang = function () {
    function langClass(_json) {

        this.json = _json;

        this.get = function (_message) {
            var args = [];
            for (var i = 1, l = arguments.length; i < l; i++) {
                args = args.concat(arguments[i]);
            }

            if (_message in this.json) {
                return ax5.util.string(this.json[_message]).format(args);
            } else {
                for (var k in this.json) {
                    if (ax5.util.right(k, _message.length) == _message) {
                        return ax5.util.string(this.json[k]).format(args);
                        break;
                    }
                }
            }
        };
    }

    return langClass;
}();
/**
 * @Object {Object} axboot.modal
 */
axboot.modal = function () {
    var modalCallback = {};

    var defaultCss = {
        width: 400,
        height: 400,
        position: {
            left: "center",
            //top: "middle",
            top: 100,
            margin: 60
        }
    };

    var defaultOption = $.extend(true, {}, defaultCss, {
        iframeLoadingMsg: "",
        iframe: {
            method: "post",
            url: "#"
        },
        closeToEsc: true,
        onStateChanged: function onStateChanged() {
            // mask
            if (this.state === "open") {
                window.axMask.open();
            } else if (this.state === "close") {
                window.axMask.close();
            }
        },
        animateTime: 100,
        zIndex: 5000,
        absolute: true,
        fullScreen: false,
        header: {
            title: "",
            btns: {
                close: {
                    label: '<i class="cqc-circle-with-cross"></i>', onClick: function onClick() {
                        window.axModal.close();
                    }
                }
            }
        }
    });

    /**
     * 지정한 조건으로 ax5 modal을 엽니다. modalConfig 를 넘기지 않으면 지정된 기본값으로 엽니다.
     * @method axboot.modal.open
     * @param {Object} modalConfig
     * @param {Number} modalConfig.width
     * @param {Number} modalConfig.height
     * @param {Object} modalConfig.position
     * @param {String} modalConfig.position.left
     * @param {String} modalConfig.position.top
     * @param {String} modalConfig.iframeLoadingMsg
     * @param {String} modalConfig.iframe.method
     * @param {String} modalConfig.iframe.url
     * @param {Boolean} modalConfig.closeToEsc
     * @param {Number} modalConfig.animateTime
     * @param {Number} modalConfig.zIndex
     * @param {Boolean} modalConfig.fullScreen
     * @param {Object} modalConfig.header
     * @param {String} modalConfig.header.title
     * @param {Function} modalConfig.sendData - 모달창에서 parent.axboot.modal.getData() 하여 호출합니다. 전달하고 싶은 변수를 return 하면 됩니다
     * @param {Function} modalConfig.callback - 모달창에서 parant.axboot.modal.callback() 으로 호출합니다.
     *
     * @example
     * ```js
     *  axboot.modal.open({
     *      width: 400,
     *      height: 400,
     *      header: false,
     *      iframe: {
     *          url: "open url"
     *          param: "param"
     *      },
     *      sendData: function(){
     *
     *      },
     *      callback: function(){
     *          axboot.modal.close();
     *      }
     *  });
     * ```
     */
    var open = function open(modalConfig) {
        window.axModal = new ax5.ui.modal({
            absolute: true,
            iframeLoadingMsg: '<i class="cqc-chequer ax-loading-icon lg"></i>'
        });

        modalConfig = $.extend(true, {}, defaultOption, modalConfig);
        if (modalConfig.modalType) {

            if (axboot.def.MODAL && axboot.def.MODAL[modalConfig.modalType]) {
                if (modalConfig.param) {
                    $.extend(true, modalConfig, { iframe: { param: modalConfig.param } });
                }
                modalConfig = $.extend(true, {}, modalConfig, axboot.def.MODAL[modalConfig.modalType]);
            }
        }

        $(document.body).addClass("modalOpened");

        this.modalCallback = modalConfig.callback;
        this.modalSendData = modalConfig.sendData;

        window.axModal.open(modalConfig);
    };

    /**
     * ax5 modal css 를 적용합니다.
     * @method axboot.modal.css
     * @param modalCss
     */
    var css = function css(modalCss) {
        modalCss = $.extend(true, {}, defaultCss, modalCss);
        window.axModal.css(modalCss);
    };
    /**
     * ax5 modal을 정렬합니다.
     * @method axboot.modal.align
     * @param modalAlign
     */
    var align = function align(modalAlign) {
        window.axModal.align(modalAlign);
    };
    /**
     * ax5 modal을 닫습니다.
     * @method axboot.modal.close
     */
    var close = function close(data) {
        window.axModal.close();
        setTimeout(function () {
            $(document.body).removeClass("modalOpened");
        }, 500);
    };
    /**
     * ax5 modal을 최소화 합니다.
     * @method axboot.modal.minimize
     */
    var minimize = function minimize() {
        window.axModal.minimize();
    };
    /**
     * ax5 modal을 최대화 합니다.
     * @methid axboot.modal.maximize
     */
    var maximize = function maximize() {
        window.axModal.maximize();
    };

    /**
     * callback 으로 정의된 함수에 전달된 파라메터를 넘겨줍니다.
     * @method axboot.modal.callback
     * @param {Object|String} data
     */
    var callback = function callback(data) {
        if (this.modalCallback) {
            this.modalCallback(data);
        }
    };

    var getData = function getData() {
        if (this.modalSendData) {
            return this.modalSendData();
        }
    };

    return {
        "open": open,
        "css": css,
        "align": align,
        "close": close,
        "minimize": minimize,
        "maximize": maximize,
        "callback": callback,
        "modalCallback": modalCallback,
        "getData": getData
    };
}();

axboot.modal2 = function () {
    var modalCallback = {};

    var defaultCss = {
        width: 400,
        height: 400,
        position: {
            left: "center",
            //top: "middle"
            top: "top",
            margin: 60
        }
    };

    var defaultOption = $.extend(true, {}, defaultCss, {
        iframeLoadingMsg: "",
        iframe: {
            method: "post",
            url: "#"
        },
        closeToEsc: true,
        onStateChanged: function onStateChanged() {
            // mask
            if (this.state === "open") {
                window.axMask2.open();
            } else if (this.state === "close") {
                window.axMask2.close();
            }
        },
        animateTime: 100,
        zIndex: 5000,
        absolute: true,
        fullScreen: false,
        header: {
            title: "",
            btns: {
                close: {
                    label: '<i class="cqc-circle-with-cross"></i>', onClick: function onClick() {
                        window.axModal2.close();
                    }
                }
            }
        }
    });

    /**
     * 지정한 조건으로 ax5 modal을 엽니다. modalConfig 를 넘기지 않으면 지정된 기본값으로 엽니다.
     * @method axboot.modal.open
     * @param {Object} modalConfig
     * @param {Number} modalConfig.width
     * @param {Number} modalConfig.height
     * @param {Object} modalConfig.position
     * @param {String} modalConfig.position.left
     * @param {String} modalConfig.position.top
     * @param {String} modalConfig.iframeLoadingMsg
     * @param {String} modalConfig.iframe.method
     * @param {String} modalConfig.iframe.url
     * @param {Boolean} modalConfig.closeToEsc
     * @param {Number} modalConfig.animateTime
     * @param {Number} modalConfig.zIndex
     * @param {Boolean} modalConfig.fullScreen
     * @param {Object} modalConfig.header
     * @param {String} modalConfig.header.title
     * @param {Function} modalConfig.sendData - 모달창에서 parent.axboot.modal.getData() 하여 호출합니다. 전달하고 싶은 변수를 return 하면 됩니다
     * @param {Function} modalConfig.callback - 모달창에서 parant.axboot.modal.callback() 으로 호출합니다.
     *
     * @example
     * ```js
     *  axboot.modal.open({
     *      width: 400,
     *      height: 400,
     *      header: false,
     *      iframe: {
     *          url: "open url"
     *          param: "param"
     *      },
     *      sendData: function(){
     *
     *      },
     *      callback: function(){
     *          axboot.modal.close();
     *      }
     *  });
     * ```
     */
    var open = function open(modalConfig) {

        modalConfig = $.extend(true, {}, defaultOption, modalConfig);
        if (modalConfig.modalType) {

            if (axboot.def.MODAL && axboot.def.MODAL[modalConfig.modalType]) {
                if (modalConfig.param) {
                    $.extend(true, modalConfig, { iframe: { param: modalConfig.param } });
                }
                modalConfig = $.extend(true, {}, modalConfig, axboot.def.MODAL[modalConfig.modalType]);
            }
        }

        $(document.body).addClass("modalOpened");

        this.modalCallback = modalConfig.callback;
        this.modalSendData = modalConfig.sendData;

        window.axModal2.open(modalConfig);
    };

    /**
     * ax5 modal css 를 적용합니다.
     * @method axboot.modal.css
     * @param modalCss
     */
    var css = function css(modalCss) {
        modalCss = $.extend(true, {}, defaultCss, modalCss);
        window.axModal2.css(modalCss);
    };
    /**
     * ax5 modal을 정렬합니다.
     * @method axboot.modal.align
     * @param modalAlign
     */
    var align = function align(modalAlign) {
        window.axModal2.align(modalAlign);
    };
    /**
     * ax5 modal을 닫습니다.
     * @method axboot.modal.close
     */
    var close = function close(data) {
        window.axModal2.close();
        setTimeout(function () {
            $(document.body).removeClass("modalOpened");
        }, 500);
    };
    /**
     * ax5 modal을 최소화 합니다.
     * @method axboot.modal.minimize
     */
    var minimize = function minimize() {
        window.axModal2.minimize();
    };
    /**
     * ax5 modal을 최대화 합니다.
     * @methid axboot.modal.maximize
     */
    var maximize = function maximize() {
        window.axModal2.maximize();
    };

    /**
     * callback 으로 정의된 함수에 전달된 파라메터를 넘겨줍니다.
     * @method axboot.modal.callback
     * @param {Object|String} data
     */
    var callback = function callback(data) {
        if (this.modalCallback) {
            this.modalCallback(data);
        }
    };

    var getData = function getData() {
        if (this.modalSendData) {
            return this.modalSendData();
        }
    };

    return {
        "open": open,
        "css": css,
        "align": align,
        "close": close,
        "minimize": minimize,
        "maximize": maximize,
        "callback": callback,
        "modalCallback": modalCallback,
        "getData": getData
    };
}();
/**
 * @Object {Object} axboot.modelFormatter
 */
axboot.modelFormatter = function () {
    var get_real_path = function get_real_path(dataPath) {
        var path = [];
        var _path = [].concat(dataPath.split(/[\.\[\]]/g));
        _path.forEach(function (n) {
            if (n !== "") path.push(n);
        });
        _path = null;
        return "'" + path.join("']['") + "'";
    };

    /**
     * @class ax5ModelFormatter
     * @param _model
     * @example
     * ```js
     * this.model = new ax5.ui.binder();
     * this.model.setModel(this.getDefaultData(), this.target);
     * this.modelFormatter = new axboot.modelFormatter(this.model); // 모델 포메터 시작
     * ```
     */
    var ax5ModelFormatter = function ax5ModelFormatter(_model) {
        this.target = _model.view_target;

        if (!(this.target instanceof jQuery)) {
            console.log("모델 뷰 타겟이 jQuery 오브젝트가 아니라서 modelFormatter 초기화에 실패 하였습니다");
            return;
        }

        /**
         * @method ax5ModelFormatter.formatting
         * @example
         * ```js
         * this.modelFormatter.formatting(); // 입력된 값을 포메팅 된 값으로 변경
         * ```
         */
        this.formatting = function () {
            this.target.find('[data-ax-path][data-ax5formatter]').ax5formatter();
        };

        /**
         * @method ax5ModelFormatter.getClearData
         * @param _data
         * @example
         * ```js
         * var data = this.modelFormatter.getClearData(this.model.get()); // 모델의 값을 포멧팅 전 값으로 치환.
         * return data;
         * ```
         */
        this.getClearData = function (_data) {
            var myData = $.extend({}, _data);
            this.target.find('[data-ax-path]').each(function () {
                var dataPath = this.getAttribute("data-ax-path");
                var pattern = this.getAttribute("data-ax5formatter");
                var value = Function("", "return this[" + get_real_path(dataPath) + "];").call(myData);
                if (typeof value !== "undefined") {
                    if (pattern in axboot.modelFormatter.clearProcessor) value = axboot.modelFormatter.clearProcessor[pattern].call(this, value);
                    Function("val", "this[" + get_real_path(dataPath) + "] = val;").call(myData, value);
                }
            });
            return myData;
        };

        this.formatting();
    };
    return ax5ModelFormatter;
}();

axboot.modelFormatter.clearProcessor = {
    "money": function money(_v) {
        return ("" + _v).replace(/\D/g, "");
    },
    "number": function number(_v) {
        return ("" + _v).replace(/\D/g, "");
    },
    "date": function date(_v) {
        return ax5.util.date("" + _v, { "return": 'yyyy-MM-dd' });
    },
    "time": function time(_v) {
        return ("" + _v).replace(/\D/g, "");
    },
    "bizno": function bizno(_v) {
        return ("" + _v).replace(/\D/g, "");
    },
    "phone": function phone(_v) {
        return ("" + _v).replace(/\D/g, "");
    },
    "customPattern": function customPattern(_v) {
        return _v;
    }
};

/**포멧터의 포멧터 패턴 확장**/
ax5.ui.formatter.formatter["chequer"] = {
    getEnterableKeyCodes: function getEnterableKeyCodes(_opts) {
        var enterableKeyCodes = {
            '189': '-' // eventKeyCode
        };
        return jQuery.extend(enterableKeyCodes, ax5.ui.formatter.formatter.ctrlKeys, ax5.ui.formatter.formatter.numKeys);
    },
    getPatternValue: function getPatternValue(_opts, optIdx, e, val, eType) {
        val = val.replace(/\D/g, "");
        var regExpPattern = /^([0-9]{2})\-?([0-9]{2})?\-?([0-9]{2})?\-?([0-9]{2})?/;
        return val.replace(regExpPattern, function (a, b) {
            var nval = [arguments[1]];
            if (arguments[2]) nval.push(arguments[2]);
            if (arguments[3]) nval.push(arguments[3]);
            if (arguments[4]) nval.push(arguments[4]);
            return nval.join("-");
        });
    }
};

/**
 * @Object {Object} axboot.formFormatter
 */
axboot.formFormatter = function () {
    /**
     * @class ax5FormFormatter
     * @param _model
     * @example
     * ```js
     * this.formFormatter = new axboot.formFormatter(this.$target); // 폼 포메터 시작
     * ```
     */
    var ax5FormFormatter = function ax5FormFormatter(_$target) {
        this.target = _$target;

        if (!(this.target instanceof jQuery)) {
            console.log("target이 jQuery 오브젝트가 아니라서 formFormatter 초기화에 실패 하였습니다");
            return;
        }

        /**
         * @method ax5FormFormatter.formatting
         * @example
         * ```js
         * this.modelFormatter.formatting(); // 입력된 값을 포메팅 된 값으로 변경
         * ```
         */
        this.formatting = function () {
            this.target.find('[data-ax5formatter]').ax5formatter();
        };

        this.formatting();
    };
    return ax5FormFormatter;
}();
/**
 * @object {Object} axboot.preparePlugin
 */
axboot.preparePlugin = function () {
    /**
     * js가 실행되는 타임. 페이지 레디 전에 미리 선언 하는 경우
     * @method axboot.preparePlugin.define
     */
    var define = function define() {

        /**
         * 기본 마스크
         * @var {ax5ui} axMask
         * @example
         * ```js
         * appMask.open();
         * appMask.close();
         * appMask.close(1000); // 1초 지연 후 마스크 닫기
         * ```
         */
        window.axMask = new ax5.ui.mask();
        window.axMask2 = new ax5.ui.mask();
        /**
         * 다이얼로그용 마스크
         * @var {ax5ui} axDialogMask
         */
        window.axDialogMask = new ax5.ui.mask();
        /**
         * ajax용 마스크
         * @var {ax5ui} axAJAXMask
         */
        window.axAJAXMask = new ax5.ui.mask({
            content: '<i class="cqc-chequer cqc-50x cqc-zoom-in-out" style="color: #ccc;"></i>'
        });
        /**
         * 프로그래스바 형태의 마스크
         * @var {ax5ui} axProgressMask
         */
        window.axProgressMask = new ax5.ui.mask({
            theme: "progress-mask",
            content: '<div class="progress">' + '<div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" style="width: 0%">' + '</div>' + '</div>'
        });
        /**
         * 기본 모달
         * @var {ax5ui} axModal
         */
        window.axModal = new ax5.ui.modal({
            absolute: true,
            iframeLoadingMsg: '<i class="cqc-chequer ax-loading-icon lg"></i>'
        });

        window.axModal2 = new ax5.ui.modal({
            absolute: true,
            iframeLoadingMsg: '<i class="cqc-chequer ax-loading-icon lg"></i>'
        });

        ax5.ui.picker_instance.setConfig({
            animateTime: 100,
            calendar: {
                control: {
                    left: '<i class="cqc-chevron-left"></i>',
                    yearTmpl: '%s',
                    monthTmpl: '%s',
                    right: '<i class="cqc-chevron-right"></i>',
                    yearFirst: true
                    /*
                     dimensions: {
                     itemPadding: 1,
                     height: 200
                     }
                     lang: {
                     year: "%s",
                     month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                     day: "%s"
                     },
                     */
                } }
        });
        ax5.ui.combobox_instance.setConfig({
            removeIcon: '<i class="cqc-cancel3"></i>'
        });
    };

    /**
     * 페이지가 레디된 다음 선언하는 경우.
     * 경우에 따라 페이지가 준비완료 상태일 때 선언해야하는 플러그인을 위해.
     * @method axboot.preparePlugin.pageStart
     */
    var pageStart = function pageStart() {

        /**
         *
         * @var {ax5ui} axDialog
         */
        window.axDialog = new ax5.ui.dialog({
            title: axboot.def.dialogTitle,
            lang: {
                "ok": "확인", "cancel": "취소"
            },
            onStateChanged: function onStateChanged() {
                if (this.state === "open") {
                    axDialogMask.open();
                } else if (this.state === "close") {
                    axDialogMask.close();
                }
            }
        });
        /**
         *
         * @var {ax5ui} axWarningDialog
         */
        window.axWarningDialog = new ax5.ui.dialog({
            title: axboot.def.dialogTitle,
            theme: "warning",
            lang: {
                "ok": "확인", "cancel": "취소"
            },
            onStateChanged: function onStateChanged() {
                if (this.state === "open") {
                    axDialogMask.open({ theme: 'danger' });
                } else if (this.state === "close") {
                    axDialogMask.close();
                }
            }
        });
        /**
         *
         * @var {ax5ui} axToast
         * @example
         * ```js
         * toast.push('Toast message', function () {
         *  // closed toast
         *  console.log(this);
         * });
         * ```
         */
        window.axToast = new ax5.ui.toast({
            icon: '<i class="cqc-megaphone"></i>',
            containerPosition: 'bottom-right',
            onStateChanged: function onStateChanged() {}
        });
        /**
         * @var {ax5ui} axWarningToast
         *
         */
        window.axWarningToast = new ax5.ui.toast({
            theme: "danger",
            icon: '<i class="cqc-warning2"></i>',
            containerPosition: "bottom-left",
            onStateChanged: function onStateChanged() {}
        });
    };

    define();

    return {
        define: define,
        pageStart: pageStart
    };
}();
axboot.requireSession = function (_cookieName) {
    if (!ax5.util.getCookie(_cookieName)) {
        if (window.opener) {
            window.close();
            window.opener.top.location.href = "/";
        } else if (top != window) {
            top.location.href = "/";
        }
    }
};
/**
 * Created by tom on 2016. 9. 2..
 */

axboot.addressPopup = {
    open: function open(cb) {
        //alert("open");
        var modalConfig = {
            width: 500,
            height: 600,
            iframe: {
                url: "/html/common/zipcode.html"
            },
            header: {
                title: "우편번호 찾기"
            },
            callback: cb
        };
        axboot.modal.open(modalConfig);
    },
    close: function close() {
        axboot.modal.close();
    }
};

//############################################################################################
//# axboot.util
//############################################################################################

axboot.util = function () {
    var setSelectionRange = function setSelectionRange(input, pos) {
        if (typeof pos == "undefined") {
            pos = input.value.length;
        }
        if (input.setSelectionRange) {
            input.focus();
            input.setSelectionRange(pos, pos);
        } else if (input.createTextRange) {
            var range = input.createTextRange();
            range.collapse(true);
            range.moveEnd('character', pos);
            range.moveStart('character', pos);
            range.select();
        } else if (input.selectionStart) {
            input.focus();
            input.selectionStart = pos;
            input.selectionEnd = pos;
        }
    };

    // form 의 input box 를 파라미터 맵으로 반환합니다.
    var getFormToParam = function getFormToParam($form) {
        var param = {};

        if ($form) {
            var aryParam = $form.serializeArray();

            $.each(aryParam, function () {
                if (param[this.name]) {
                    if (!param[this.name].push) {
                        param[this.name] = [param[this.name]];
                    }
                    param[this.name].push(this.value || '');
                } else {
                    param[this.name] = this.value || '';
                }
            });
        }

        return param;
    };

    var getBindingTargets = function getBindingTargets(obj) {
        var aryBindingTarget = [];

        if (ax5.util.isNothing(obj) || !obj.data) {
            return aryBindingTarget;
        }

        var bindingTarget = obj.data('bindingTarget');

        // 바인딩 타겟 존제 유무
        if (!ax5.util.isNothing(bindingTarget)) {
            if (bindingTarget.startsWith('[') && bindingTarget.endsWith(']')) {
                aryBindingTarget = ax5.util.parseJson(bindingTarget);
            } else {
                aryBindingTarget.push(bindingTarget);
            }
        }

        return aryBindingTarget;
    };

    var getObjectType = function getObjectType(obj) {
        var objectType;

        if (obj.hasOwnProperty('name') && obj.name.toUpperCase() == 'GRID') {
            objectType = 'GRID';
        } else if (obj.hasOwnProperty('name') && obj.name.toUpperCase() == 'UPLOADER') {
            objectType = 'UPLOADER';
        } else if (obj.hasOwnProperty('target') && obj.target.length > 0 && obj.target[0].tagName.toUpperCase() === 'FORM') {
            objectType = 'FORM';
        }

        return objectType;
    };

    var getCommandOptionsToAjaxConfig = function getCommandOptionsToAjaxConfig(options) {
        var tempData = {};
        var ajaxConfig = {};

        if (ax5.util.getType(options) === 'string') {
            ajaxConfig['url'] = options;
        } else if (ax5.util.getType(options) === 'object') {
            if (!ax5.util.isNothing(options.data)) {
                if (ax5.util.getType(options.data) === 'array') {
                    for (var i = 0; i < options.data.length; i++) {
                        tempData = $.extend(true, tempData, options.data[i]);
                    }
                } else if (ax5.util.getType(options.data) === 'object') {
                    tempData = $.extend(true, tempData, options.data);
                }
            }

            options.data = {};

            ajaxConfig['data'] = $.extend(true, {}, tempData);
            ajaxConfig = $.extend(true, {}, ajaxConfig, options);
        }

        return ajaxConfig;
    };

    // 그리드의 행 상태값을 반환합니다.
    var getRowState = function getRowState(data) {
        var rowState = '';

        if (data['__created__'] && data['__modified__']) {
            rowState = 'I';
        } else if (!data['__created__'] && data['__modified__']) {
            rowState = 'U';
        } else if (data['__selected__']) {
            rowState = 'R';
        } else {
            rowState = '';
        }

        return rowState;
    };

    // 그리드의 행이 선택되어있는지 확인합니다.
    var isSelectedRow = function isSelectedRow(data) {
        if (data['__selected__']) {
            return true;
        }

        return false;
    };

    var isSaveRow = function isSaveRow(data) {
        var isSaveRow = false;

        if (data['__created__'] || data['__modified__']) {
            isSaveRow = true;
        }

        return isSaveRow;
    };

    var getActiveTab = function getActiveTab(selectedTab) {
        var initTab = selectedTab.$target.data('initTab');
        var childFrame;

        if (selectedTab.$target.find('[data-frame-type="tab-iframe"]').length > 0) {
            childFrame = selectedTab.$target.find('[data-frame-type="tab-iframe"]')[0].contentWindow;
        }

        if (ax5.util.isNothing(initTab)) {
            initTab = false;
        }

        selectedTab['initTab'] = initTab;
        selectedTab['childFrame'] = childFrame;

        return selectedTab;
    };

    var bindingTarget = function bindingTarget(target, rowItem) {
        var aryBindingTarget = axboot.util.getBindingTargets(target);
        var cmdFocus = '';
        var cmdReadonly = '';

        for (var i = 0; i < aryBindingTarget.length; i++) {
            if (fnObj.hasOwnProperty(aryBindingTarget[i])) {
                cmdFocus = '';

                fnObj[aryBindingTarget[i]].enable();

                if (axboot.util.getRowState(rowItem) == 'I') {
                    fnObj[aryBindingTarget[i]].target.find(':input').attr('readonly', false);
                    fnObj[aryBindingTarget[i]].target.find(':input').attr('disabled', false);

                    fnObj[aryBindingTarget[i]].target.find('[data-ax-cmd-readonly="insert"]').attr('readonly', true);
                    fnObj[aryBindingTarget[i]].target.find('[data-ax-cmd-disabled="insert"]').attr('disabled', true);

                    fnObj[aryBindingTarget[i]].target.find('[data-ax-cmd-focus]').each(function (index, element) {
                        cmdFocus = $(element).attr('data-ax-cmd-focus');

                        if (cmdFocus.indexOf('add') > -1) {
                            $(element).focus();
                        }
                    });
                } else {
                    fnObj[aryBindingTarget[i]].target.find('[data-ax-cmd-readonly="update"]').attr('readonly', true);
                    fnObj[aryBindingTarget[i]].target.find('[data-ax-cmd-disabled="update"]').attr('disabled', true);

                    fnObj[aryBindingTarget[i]].target.find('[data-ax-cmd-focus]').each(function (index, element) {
                        cmdFocus = $(element).attr('data-ax-cmd-focus');

                        if (cmdFocus.indexOf('update') > -1) {
                            $(element).focus();
                        }
                    });
                }

                fnObj[aryBindingTarget[i]].target.find('[data-ax-readonly="true"]').attr('readonly', true);
                fnObj[aryBindingTarget[i]].setData(rowItem);
            }
        }
    };

    // axboot.util.resizeSplitLayout($('[data-ax5layout="ax1"]'), ['*', 100]);
    var resizeSplitLayout = function resizeSplitLayout($target, option) {
        var sizeArray = [];

        if (ax5.util.isArray(option)) {
            sizeArray = option;
        } else if (ax5.util.isNumber(option) || ax5.util.isString(option)) {
            sizeArray.push(option);
        } else {
            return;
        }

        var config = $target.attr('data-config');

        if (config.startsWith('{') && config.endsWith('}')) {
            config = ax5.util.parseJson(config, true);
        }

        if (ax5.util.isObject(config)) {
            var sizeOption = '';

            if (config['orientation'] == 'vertical') {
                sizeOption = 'width';
            } else if (config['orientation'] == 'horizontal') {
                sizeOption = 'height';
            }

            if (sizeOption == 'width' || sizeOption == 'height') {
                var size = '';

                $target.find('[data-split-panel]').each(function (index, element) {
                    if (index < sizeArray.length) {
                        var widthJson = $(element).attr('data-split-panel');

                        size = sizeArray[index];

                        if (ax5.util.isString(size)) {
                            size = '\'' + size + '\'';
                        }

                        $(element).attr('data-split-panel', '{' + sizeOption + ': ' + size + '}');
                    }
                });

                $target.ax5layout();
            }
        }
    };

    var getResponseType = function getResponseType(data) {
        var responseType = 'data';

        if (!ax5.util.isNothing(data) && data.hasOwnProperty('errorCount') && data.hasOwnProperty('fieldErrors')) {
            responseType = 'validation';
        }

        return responseType;
    };

    var responseResultMsg = function responseResultMsg(data) {
        var responseType = axboot.util.getResponseType(data);

        if (responseType == 'validation') {
            if (data.errorCount > 0) {
                var errorMessage = '';
                var inputField = '';

                $.each(data.fieldErrors, function (index, collection) {
                    inputField = collection.field;

                    if (inputField != '') {
                        errorMessage += inputField + ' : ' + collection.message + '\n';
                    } else {
                        errorMessage += collection.message + '\n';
                    }
                });

                axDialog.alert({
                    title: '오류 알림',
                    theme: 'danger',
                    msg: errorMessage,
                    width: 500
                });
            } else {
                if (!ax5.util.isNothing(data) && !ax5.util.isNothing(data.responseText)) {
                    axToast.push(data.responseText);
                }
            }
        }
    };

    var getNextSortOrder = function getNextSortOrder(gridObj, sortColumn) {
        var nextSortOrder;

        if (gridObj.getData().length == 0) {
            nextSortOrder = 1;
        } else {
            nextSortOrder = Math.max.apply(Math, gridObj.getData().map(function (o) {
                return o[sortColumn];
            }));

            if (isNaN(nextSortOrder)) {
                nextSortOrder = gridObj.getData().length;
            }

            nextSortOrder += 1;
        }

        return nextSortOrder;
    };

    var camelToUnderscore = function camelToUnderscore(val) {
        return val.replace(/([A-Z])/g, function ($1) {
            return '_' + $1.toLowerCase();
        });
    };

    return {
        'setFocusPosition': setSelectionRange,
        'getFormToParam': getFormToParam,
        'getObjectType': getObjectType,
        'getBindingTargets': getBindingTargets,
        'getCommandOptionsToAjaxConfig': getCommandOptionsToAjaxConfig,
        'getRowState': getRowState,
        'isSelectedRow': isSelectedRow,
        'isSaveRow': isSaveRow,
        'getActiveTab': getActiveTab,
        'bindingTarget': bindingTarget,
        'getResponseType': getResponseType,
        'resizeSplitLayout': resizeSplitLayout,
        'responseResultMsg': responseResultMsg,
        'getNextSortOrder': getNextSortOrder,
        'camelToUnderscore': camelToUnderscore
    };
}();
/* ========================================================================
 * Bootstrap: dropdown.js v3.3.7
 * http://getbootstrap.com/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
    'use strict';

    // DROPDOWN CLASS DEFINITION
    // =========================

    var backdrop = '.dropdown-backdrop';
    var toggle = '[data-toggle="dropdown"]';
    var Dropdown = function Dropdown(element) {
        $(element).on('click.bs.dropdown', this.toggle);
    };

    Dropdown.VERSION = '3.3.7';

    function getParent($this) {
        var selector = $this.attr('data-target');

        if (!selector) {
            selector = $this.attr('href');
            selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, ''); // strip for ie7
        }

        var $parent = selector && $(selector);

        return $parent && $parent.length ? $parent : $this.parent();
    }

    function clearMenus(e) {
        if (e && e.which === 3) return;
        $(backdrop).remove();
        $(toggle).each(function () {
            var $this = $(this);
            var $parent = getParent($this);
            var relatedTarget = { relatedTarget: this };

            if (!$parent.hasClass('open')) return;

            if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return;

            $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget));

            if (e.isDefaultPrevented()) return;

            $this.attr('aria-expanded', 'false');
            $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget));
        });
    }

    Dropdown.prototype.toggle = function (e) {
        var $this = $(this);

        if ($this.is('.disabled, :disabled')) return;

        var $parent = getParent($this);
        var isActive = $parent.hasClass('open');

        clearMenus();

        if (!isActive) {
            if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
                // if mobile we use a backdrop because click events don't delegate
                $(document.createElement('div')).addClass('dropdown-backdrop').insertAfter($(this)).on('click', clearMenus);
            }

            var relatedTarget = { relatedTarget: this };
            $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget));

            if (e.isDefaultPrevented()) return;

            $this.trigger('focus').attr('aria-expanded', 'true');

            $parent.toggleClass('open').trigger($.Event('shown.bs.dropdown', relatedTarget));
        }

        return false;
    };

    Dropdown.prototype.keydown = function (e) {
        if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return;

        var $this = $(this);

        e.preventDefault();
        e.stopPropagation();

        if ($this.is('.disabled, :disabled')) return;

        var $parent = getParent($this);
        var isActive = $parent.hasClass('open');

        if (!isActive && e.which != 27 || isActive && e.which == 27) {
            if (e.which == 27) $parent.find(toggle).trigger('focus');
            return $this.trigger('click');
        }

        var desc = ' li:not(.disabled):visible a';
        var $items = $parent.find('.dropdown-menu' + desc);

        if (!$items.length) return;

        var index = $items.index(e.target);

        if (e.which == 38 && index > 0) index--; // up
        if (e.which == 40 && index < $items.length - 1) index++; // down
        if (!~index) index = 0;

        $items.eq(index).trigger('focus');
    };

    // DROPDOWN PLUGIN DEFINITION
    // ==========================

    function Plugin(option) {
        return this.each(function () {
            var $this = $(this);
            var data = $this.data('bs.dropdown');

            if (!data) $this.data('bs.dropdown', data = new Dropdown(this));
            if (typeof option == 'string') data[option].call($this);
        });
    }

    var old = $.fn.dropdown;

    $.fn.dropdown = Plugin;
    $.fn.dropdown.Constructor = Dropdown;

    // DROPDOWN NO CONFLICT
    // ====================

    $.fn.dropdown.noConflict = function () {
        $.fn.dropdown = old;
        return this;
    };

    // APPLY TO STANDARD DROPDOWN ELEMENTS
    // ===================================

    $(document).on('click.bs.dropdown.data-api', clearMenus).on('click.bs.dropdown.data-api', '.dropdown form', function (e) {
        e.stopPropagation();
    }).on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle).on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown).on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown);
}(jQuery);
/* ========================================================================
 * Bootstrap: modal.js v3.3.7
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
    'use strict';

    // MODAL CLASS DEFINITION
    // ======================

    var Modal = function Modal(element, options) {
        this.options = options;
        this.$body = $(document.body);
        this.$element = $(element);
        this.$dialog = this.$element.find('.modal-dialog');
        this.$backdrop = null;
        this.isShown = null;
        this.originalBodyPad = null;
        this.scrollbarWidth = 0;
        this.ignoreBackdropClick = false;

        if (this.options.remote) {
            this.$element.find('.modal-content').load(this.options.remote, $.proxy(function () {
                this.$element.trigger('loaded.bs.modal');
            }, this));
        }
    };

    Modal.VERSION = '3.3.7';

    Modal.TRANSITION_DURATION = 300;
    Modal.BACKDROP_TRANSITION_DURATION = 150;

    Modal.DEFAULTS = {
        backdrop: true,
        keyboard: true,
        show: true
    };

    Modal.prototype.toggle = function (_relatedTarget) {
        return this.isShown ? this.hide() : this.show(_relatedTarget);
    };

    Modal.prototype.show = function (_relatedTarget) {
        var that = this;
        var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget });

        this.$element.trigger(e);

        if (this.isShown || e.isDefaultPrevented()) return;

        this.isShown = true;

        this.checkScrollbar();
        this.setScrollbar();
        this.$body.addClass('modal-open');

        this.escape();
        this.resize();

        this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this));

        this.$dialog.on('mousedown.dismiss.bs.modal', function () {
            that.$element.one('mouseup.dismiss.bs.modal', function (e) {
                if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true;
            });
        });

        this.backdrop(function () {
            var transition = $.support.transition && that.$element.hasClass('fade');

            if (!that.$element.parent().length) {
                that.$element.appendTo(that.$body); // don't move modals dom position
            }

            that.$element.show().scrollTop(0);

            that.adjustDialog();

            if (transition) {
                that.$element[0].offsetWidth; // force reflow
            }

            that.$element.addClass('in');

            that.enforceFocus();

            var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget });

            transition ? that.$dialog // wait for modal to slide in
            .one('bsTransitionEnd', function () {
                that.$element.trigger('focus').trigger(e);
            }).emulateTransitionEnd(Modal.TRANSITION_DURATION) : that.$element.trigger('focus').trigger(e);
        });
    };

    Modal.prototype.hide = function (e) {
        if (e) e.preventDefault();

        e = $.Event('hide.bs.modal');

        this.$element.trigger(e);

        if (!this.isShown || e.isDefaultPrevented()) return;

        this.isShown = false;

        this.escape();
        this.resize();

        $(document).off('focusin.bs.modal');

        this.$element.removeClass('in').off('click.dismiss.bs.modal').off('mouseup.dismiss.bs.modal');

        this.$dialog.off('mousedown.dismiss.bs.modal');

        $.support.transition && this.$element.hasClass('fade') ? this.$element.one('bsTransitionEnd', $.proxy(this.hideModal, this)).emulateTransitionEnd(Modal.TRANSITION_DURATION) : this.hideModal();
    };

    Modal.prototype.enforceFocus = function () {
        $(document).off('focusin.bs.modal') // guard against infinite focus loop
        .on('focusin.bs.modal', $.proxy(function (e) {
            if (document !== e.target && this.$element[0] !== e.target && !this.$element.has(e.target).length) {
                this.$element.trigger('focus');
            }
        }, this));
    };

    Modal.prototype.escape = function () {
        if (this.isShown && this.options.keyboard) {
            this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
                e.which == 27 && this.hide();
            }, this));
        } else if (!this.isShown) {
            this.$element.off('keydown.dismiss.bs.modal');
        }
    };

    Modal.prototype.resize = function () {
        if (this.isShown) {
            $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this));
        } else {
            $(window).off('resize.bs.modal');
        }
    };

    Modal.prototype.hideModal = function () {
        var that = this;
        this.$element.hide();
        this.backdrop(function () {
            that.$body.removeClass('modal-open');
            that.resetAdjustments();
            that.resetScrollbar();
            that.$element.trigger('hidden.bs.modal');
        });
    };

    Modal.prototype.removeBackdrop = function () {
        this.$backdrop && this.$backdrop.remove();
        this.$backdrop = null;
    };

    Modal.prototype.backdrop = function (callback) {
        var that = this;
        var animate = this.$element.hasClass('fade') ? 'fade' : '';

        if (this.isShown && this.options.backdrop) {
            var doAnimate = $.support.transition && animate;

            this.$backdrop = $(document.createElement('div')).addClass('modal-backdrop ' + animate).appendTo(this.$body);

            this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
                if (this.ignoreBackdropClick) {
                    this.ignoreBackdropClick = false;
                    return;
                }
                if (e.target !== e.currentTarget) return;
                this.options.backdrop == 'static' ? this.$element[0].focus() : this.hide();
            }, this));

            if (doAnimate) this.$backdrop[0].offsetWidth; // force reflow

            this.$backdrop.addClass('in');

            if (!callback) return;

            doAnimate ? this.$backdrop.one('bsTransitionEnd', callback).emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) : callback();
        } else if (!this.isShown && this.$backdrop) {
            this.$backdrop.removeClass('in');

            var callbackRemove = function callbackRemove() {
                that.removeBackdrop();
                callback && callback();
            };
            $.support.transition && this.$element.hasClass('fade') ? this.$backdrop.one('bsTransitionEnd', callbackRemove).emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) : callbackRemove();
        } else if (callback) {
            callback();
        }
    };

    // these following methods are used to handle overflowing modals

    Modal.prototype.handleUpdate = function () {
        this.adjustDialog();
    };

    Modal.prototype.adjustDialog = function () {
        var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight;

        this.$element.css({
            paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
            paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
        });
    };

    Modal.prototype.resetAdjustments = function () {
        this.$element.css({
            paddingLeft: '',
            paddingRight: ''
        });
    };

    Modal.prototype.checkScrollbar = function () {
        var fullWindowWidth = window.innerWidth;
        if (!fullWindowWidth) {
            // workaround for missing window.innerWidth in IE8
            var documentElementRect = document.documentElement.getBoundingClientRect();
            fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left);
        }
        this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth;
        this.scrollbarWidth = this.measureScrollbar();
    };

    Modal.prototype.setScrollbar = function () {
        var bodyPad = parseInt(this.$body.css('padding-right') || 0, 10);
        this.originalBodyPad = document.body.style.paddingRight || '';
        if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth);
    };

    Modal.prototype.resetScrollbar = function () {
        this.$body.css('padding-right', this.originalBodyPad);
    };

    Modal.prototype.measureScrollbar = function () {
        // thx walsh
        var scrollDiv = document.createElement('div');
        scrollDiv.className = 'modal-scrollbar-measure';
        this.$body.append(scrollDiv);
        var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        this.$body[0].removeChild(scrollDiv);
        return scrollbarWidth;
    };

    // MODAL PLUGIN DEFINITION
    // =======================

    function Plugin(option, _relatedTarget) {
        return this.each(function () {
            var $this = $(this);
            var data = $this.data('bs.modal');
            var options = $.extend({}, Modal.DEFAULTS, $this.data(), (typeof option === "undefined" ? "undefined" : _typeof(option)) == 'object' && option);

            if (!data) $this.data('bs.modal', data = new Modal(this, options));
            if (typeof option == 'string') data[option](_relatedTarget);else if (options.show) data.show(_relatedTarget);
        });
    }

    var old = $.fn.modal;

    $.fn.modal = Plugin;
    $.fn.modal.Constructor = Modal;

    // MODAL NO CONFLICT
    // =================

    $.fn.modal.noConflict = function () {
        $.fn.modal = old;
        return this;
    };

    // MODAL DATA-API
    // ==============

    $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
        var $this = $(this);
        var href = $this.attr('href');
        var $target = $($this.attr('data-target') || href && href.replace(/.*(?=#[^\s]+$)/, '')); // strip for ie7
        var option = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data());

        if ($this.is('a')) e.preventDefault();

        $target.one('show.bs.modal', function (showEvent) {
            if (showEvent.isDefaultPrevented()) return; // only register focus restorer if modal will actually get shown
            $target.one('hidden.bs.modal', function () {
                $this.is(':visible') && $this.trigger('focus');
            });
        });
        Plugin.call($target, option, this);
    });
}(jQuery);
+function ($) {
    'use strict';

    // TOOLTIP PUBLIC CLASS DEFINITION
    // ===============================

    var Tooltip = function Tooltip(element, options) {
        this.type = null;
        this.options = null;
        this.enabled = null;
        this.timeout = null;
        this.hoverState = null;
        this.$element = null;
        this.inState = null;

        this.init('tooltip', element, options);
    };

    Tooltip.VERSION = '3.3.7';

    Tooltip.TRANSITION_DURATION = 150;

    Tooltip.DEFAULTS = {
        animation: true,
        placement: 'top',
        selector: false,
        template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: 'hover focus',
        title: '',
        delay: 0,
        html: false,
        container: false,
        viewport: {
            selector: 'body',
            padding: 0
        }
    };

    Tooltip.prototype.init = function (type, element, options) {
        this.enabled = true;
        this.type = type;
        this.$element = $(element);
        this.options = this.getOptions(options);
        this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : this.options.viewport.selector || this.options.viewport);
        this.inState = { click: false, hover: false, focus: false };

        if (this.$element[0] instanceof document.constructor && !this.options.selector) {
            throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!');
        }

        var triggers = this.options.trigger.split(' ');

        for (var i = triggers.length; i--;) {
            var trigger = triggers[i];

            if (trigger == 'click') {
                this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this));
            } else if (trigger != 'manual') {
                var eventIn = trigger == 'hover' ? 'mouseenter' : 'focusin';
                var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout';

                this.$element.on(eventIn + '.' + this.type, this.options.selector, $.proxy(this.enter, this));
                this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this));
            }
        }

        this.options.selector ? this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' }) : this.fixTitle();
    };

    Tooltip.prototype.getDefaults = function () {
        return Tooltip.DEFAULTS;
    };

    Tooltip.prototype.getOptions = function (options) {
        options = $.extend({}, this.getDefaults(), this.$element.data(), options);

        if (options.delay && typeof options.delay == 'number') {
            options.delay = {
                show: options.delay,
                hide: options.delay
            };
        }

        return options;
    };

    Tooltip.prototype.getDelegateOptions = function () {
        var options = {};
        var defaults = this.getDefaults();

        this._options && $.each(this._options, function (key, value) {
            if (defaults[key] != value) options[key] = value;
        });

        return options;
    };

    Tooltip.prototype.enter = function (obj) {
        var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data('bs.' + this.type);

        if (!self) {
            self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
            $(obj.currentTarget).data('bs.' + this.type, self);
        }

        if (obj instanceof $.Event) {
            self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true;
        }

        if (self.tip().hasClass('in') || self.hoverState == 'in') {
            self.hoverState = 'in';
            return;
        }

        clearTimeout(self.timeout);

        self.hoverState = 'in';

        if (!self.options.delay || !self.options.delay.show) return self.show();

        self.timeout = setTimeout(function () {
            if (self.hoverState == 'in') self.show();
        }, self.options.delay.show);
    };

    Tooltip.prototype.isInStateTrue = function () {
        for (var key in this.inState) {
            if (this.inState[key]) return true;
        }

        return false;
    };

    Tooltip.prototype.leave = function (obj) {
        var self = obj instanceof this.constructor ? obj : $(obj.currentTarget).data('bs.' + this.type);

        if (!self) {
            self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
            $(obj.currentTarget).data('bs.' + this.type, self);
        }

        if (obj instanceof $.Event) {
            self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false;
        }

        if (self.isInStateTrue()) return;

        clearTimeout(self.timeout);

        self.hoverState = 'out';

        if (!self.options.delay || !self.options.delay.hide) return self.hide();

        self.timeout = setTimeout(function () {
            if (self.hoverState == 'out') self.hide();
        }, self.options.delay.hide);
    };

    Tooltip.prototype.show = function () {
        var e = $.Event('show.bs.' + this.type);

        if (this.hasContent() && this.enabled) {
            this.$element.trigger(e);

            var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
            if (e.isDefaultPrevented() || !inDom) return;
            var that = this;

            var $tip = this.tip();

            var tipId = this.getUID(this.type);

            this.setContent();
            $tip.attr('id', tipId);
            this.$element.attr('aria-describedby', tipId);

            if (this.options.animation) $tip.addClass('fade');

            var placement = typeof this.options.placement == 'function' ? this.options.placement.call(this, $tip[0], this.$element[0]) : this.options.placement;

            var autoToken = /\s?auto?\s?/i;
            var autoPlace = autoToken.test(placement);
            if (autoPlace) placement = placement.replace(autoToken, '') || 'top';

            $tip.detach().css({ top: 0, left: 0, display: 'block' }).addClass(placement).data('bs.' + this.type, this);

            this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element);
            this.$element.trigger('inserted.bs.' + this.type);

            var pos = this.getPosition();
            var actualWidth = $tip[0].offsetWidth;
            var actualHeight = $tip[0].offsetHeight;

            if (autoPlace) {
                var orgPlacement = placement;
                var viewportDim = this.getPosition(this.$viewport);

                placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top' : placement == 'top' && pos.top - actualHeight < viewportDim.top ? 'bottom' : placement == 'right' && pos.right + actualWidth > viewportDim.width ? 'left' : placement == 'left' && pos.left - actualWidth < viewportDim.left ? 'right' : placement;

                $tip.removeClass(orgPlacement).addClass(placement);
            }

            var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight);

            this.applyPlacement(calculatedOffset, placement);

            var complete = function complete() {
                var prevHoverState = that.hoverState;
                that.$element.trigger('shown.bs.' + that.type);
                that.hoverState = null;

                if (prevHoverState == 'out') that.leave(that);
            };

            $.support.transition && this.$tip.hasClass('fade') ? $tip.one('bsTransitionEnd', complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();
        }
    };

    Tooltip.prototype.applyPlacement = function (offset, placement) {
        var $tip = this.tip();
        var width = $tip[0].offsetWidth;
        var height = $tip[0].offsetHeight;

        // manually read margins because getBoundingClientRect includes difference
        var marginTop = parseInt($tip.css('margin-top'), 10);
        var marginLeft = parseInt($tip.css('margin-left'), 10);

        // we must check for NaN for ie 8/9
        if (isNaN(marginTop)) marginTop = 0;
        if (isNaN(marginLeft)) marginLeft = 0;

        offset.top += marginTop;
        offset.left += marginLeft;

        // $.fn.offset doesn't round pixel values
        // so we use setOffset directly with our own function B-0
        $.offset.setOffset($tip[0], $.extend({
            using: function using(props) {
                $tip.css({
                    top: Math.round(props.top),
                    left: Math.round(props.left)
                });
            }
        }, offset), 0);

        $tip.addClass('in');

        // check to see if placing tip in new offset caused the tip to resize itself
        var actualWidth = $tip[0].offsetWidth;
        var actualHeight = $tip[0].offsetHeight;

        if (placement == 'top' && actualHeight != height) {
            offset.top = offset.top + height - actualHeight;
        }

        var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight);

        if (delta.left) offset.left += delta.left;else offset.top += delta.top;

        var isVertical = /top|bottom/.test(placement);
        var arrowDelta = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight;
        var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight';

        $tip.offset(offset);
        this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical);
    };

    Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
        this.arrow().css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%').css(isVertical ? 'top' : 'left', '');
    };

    Tooltip.prototype.setContent = function () {
        var $tip = this.tip();
        var title = this.getTitle();

        $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title);
        $tip.removeClass('fade in top bottom left right');
    };

    Tooltip.prototype.hide = function (callback) {
        var that = this;
        var $tip = $(this.$tip);
        var e = $.Event('hide.bs.' + this.type);

        function complete() {
            if (that.hoverState != 'in') $tip.detach();
            if (that.$element) {
                // TODO: Check whether guarding this code with this `if` is really necessary.
                that.$element.removeAttr('aria-describedby').trigger('hidden.bs.' + that.type);
            }
            callback && callback();
        }

        this.$element.trigger(e);

        if (e.isDefaultPrevented()) return;

        $tip.removeClass('in');

        $.support.transition && $tip.hasClass('fade') ? $tip.one('bsTransitionEnd', complete).emulateTransitionEnd(Tooltip.TRANSITION_DURATION) : complete();

        this.hoverState = null;

        return this;
    };

    Tooltip.prototype.fixTitle = function () {
        var $e = this.$element;
        if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
            $e.attr('data-original-title', $e.attr('title') || '').attr('title', '');
        }
    };

    Tooltip.prototype.hasContent = function () {
        return this.getTitle();
    };

    Tooltip.prototype.getPosition = function ($element) {
        $element = $element || this.$element;

        var el = $element[0];
        var isBody = el.tagName == 'BODY';

        var elRect = el.getBoundingClientRect();
        if (elRect.width == null) {
            // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
            elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top });
        }
        var isSvg = window.SVGElement && el instanceof window.SVGElement;
        // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
        // See https://github.com/twbs/bootstrap/issues/20280
        var elOffset = isBody ? { top: 0, left: 0 } : isSvg ? null : $element.offset();
        var scroll = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() };
        var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null;

        return $.extend({}, elRect, scroll, outerDims, elOffset);
    };

    Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
        return placement == 'bottom' ? { top: pos.top + pos.height, left: pos.left + pos.width / 2 - actualWidth / 2 } : placement == 'top' ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } : placement == 'left' ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */{ top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width };
    };

    Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
        var delta = { top: 0, left: 0 };
        if (!this.$viewport) return delta;

        var viewportPadding = this.options.viewport && this.options.viewport.padding || 0;
        var viewportDimensions = this.getPosition(this.$viewport);

        if (/right|left/.test(placement)) {
            var topEdgeOffset = pos.top - viewportPadding - viewportDimensions.scroll;
            var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight;
            if (topEdgeOffset < viewportDimensions.top) {
                // top overflow
                delta.top = viewportDimensions.top - topEdgeOffset;
            } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) {
                // bottom overflow
                delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset;
            }
        } else {
            var leftEdgeOffset = pos.left - viewportPadding;
            var rightEdgeOffset = pos.left + viewportPadding + actualWidth;
            if (leftEdgeOffset < viewportDimensions.left) {
                // left overflow
                delta.left = viewportDimensions.left - leftEdgeOffset;
            } else if (rightEdgeOffset > viewportDimensions.right) {
                // right overflow
                delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset;
            }
        }

        return delta;
    };

    Tooltip.prototype.getTitle = function () {
        var title;
        var $e = this.$element;
        var o = this.options;

        title = $e.attr('data-original-title') || (typeof o.title == 'function' ? o.title.call($e[0]) : o.title);

        return title;
    };

    Tooltip.prototype.getUID = function (prefix) {
        do {
            prefix += ~~(Math.random() * 1000000);
        } while (document.getElementById(prefix));
        return prefix;
    };

    Tooltip.prototype.tip = function () {
        if (!this.$tip) {
            this.$tip = $(this.options.template);
            if (this.$tip.length != 1) {
                throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!');
            }
        }
        return this.$tip;
    };

    Tooltip.prototype.arrow = function () {
        return this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow');
    };

    Tooltip.prototype.enable = function () {
        this.enabled = true;
    };

    Tooltip.prototype.disable = function () {
        this.enabled = false;
    };

    Tooltip.prototype.toggleEnabled = function () {
        this.enabled = !this.enabled;
    };

    Tooltip.prototype.toggle = function (e) {
        var self = this;
        if (e) {
            self = $(e.currentTarget).data('bs.' + this.type);
            if (!self) {
                self = new this.constructor(e.currentTarget, this.getDelegateOptions());
                $(e.currentTarget).data('bs.' + this.type, self);
            }
        }

        if (e) {
            self.inState.click = !self.inState.click;
            if (self.isInStateTrue()) self.enter(self);else self.leave(self);
        } else {
            self.tip().hasClass('in') ? self.leave(self) : self.enter(self);
        }
    };

    Tooltip.prototype.destroy = function () {
        var that = this;
        clearTimeout(this.timeout);
        this.hide(function () {
            that.$element.off('.' + that.type).removeData('bs.' + that.type);
            if (that.$tip) {
                that.$tip.detach();
            }
            that.$tip = null;
            that.$arrow = null;
            that.$viewport = null;
            that.$element = null;
        });
    };

    // TOOLTIP PLUGIN DEFINITION
    // =========================

    function Plugin(option) {
        return this.each(function () {
            var $this = $(this);
            var data = $this.data('bs.tooltip');
            var options = (typeof option === "undefined" ? "undefined" : _typeof(option)) == 'object' && option;

            if (!data && /destroy|hide/.test(option)) return;
            if (!data) $this.data('bs.tooltip', data = new Tooltip(this, options));
            if (typeof option == 'string') data[option]();
        });
    }

    var old = $.fn.tooltip;

    $.fn.tooltip = Plugin;
    $.fn.tooltip.Constructor = Tooltip;

    // TOOLTIP NO CONFLICT
    // ===================

    $.fn.tooltip.noConflict = function () {
        $.fn.tooltip = old;
        return this;
    };
}(jQuery);
/**
 * @function axboot.gridBuilder
 * @param {Object} _config
 * @example
 * ```js
 * this.target = axboot.gridBuilder({
 *    showLineNumber: false,
 *    showRowSelector: false,
 *    frozenColumnIndex: 0,
 *    target: $('[data-ax5grid="grid-view-01"]'),
 *    columns: [
 *        //menuId
 *        {key: "grpAuthCd", label: "권한그룹코드", width: 80, align: "center"},
 *        {key: "grpAuthNm", label: "권한그룹명", width: 160, align: "left"},
 *        {key: "useYn", label: "권한적용", editor: "checkYn"},
 *        {key: "schAh", label: "조회", width: 50, align: "center", editor: "menu-program-auth-checkYn"},
 *        /// --> 이것들을 list로 담아서  [PUT] "/api/v2/menu/auth"
 *    ],
 *    body: {
 *        onClick: function () {
 *            // this.self.select(this.dindex);
 *        }
 *    }
 * });
 * ```
 */
axboot.gridBuilder = function () {
    var defaultGridConfig = {
        showLineNumber: true,
        lineNumberColumnWidth: 50,
        rowSelectorColumnWidth: 28,
        header: {
            align: 'center',
            columnHeight: 30
        },
        body: {
            columnHeight: 30
        },
        page: {
            navigationItemCount: 9,
            height: 30,
            display: true,
            firstIcon: '<i class="cqc-controller-jump-to-start"></i>',
            prevIcon: '<i class="cqc-triangle-left"></i>',
            nextIcon: '<i class="cqc-triangle-right"></i>',
            lastIcon: '<i class="cqc-controller-next"></i>'
        },
        tree: {
            use: false,
            indentWidth: 20,
            arrowWidth: 15,
            iconWidth: 18,
            icons: {
                openedArrow: '<i class="fa fa-caret-down" aria-hidden="true"></i> ',
                collapsedArrow: '<i class="fa fa-caret-right" aria-hidden="true"></i> ',
                groupIcon: '<i class="fa fa-folder-open" aria-hidden="true"></i> ',
                collapsedGroupIcon: '<i class="fa fa-folder" aria-hidden="true"></i> ',
                itemIcon: '<i class="fa fa-circle" aria-hidden="true"></i> '
            }
        }
    };

    return function (_config, gridView) {
        var myGridConfig = $.extend(true, {}, defaultGridConfig, _config);

        myGridConfig.page.onChange = function () {
            if (gridView != undefined && gridView != null) {
                gridView.setPageNo(this.page.selectPage);
            }

            // 2018.06.25 (이상훈) : myGridConfig.onPageChange 구현 메소드 안에서 this 를 사용할 수 있도록 수정.
            //myGridConfig.onPageChange(this.page.selectPage);
            myGridConfig.onPageChange.call(this, this.page.selectPage);
        };

        if (!myGridConfig.body.onDBLClick) {
            myGridConfig.body.onDBLClick = function () {
                this.self.select(this.dindex, { selectedClear: true });

                var rowItem = this.list[this.dindex];

                if (!ax5.util.isNothing(myGridConfig.onItemDblClick) && ax5.util.isFunction(myGridConfig.onItemDblClick)) {
                    //myGridConfig.onItemDblClick(rowItem);

                    // 2018.06.25 (이상훈) : myGridConfig.onItemDblClick 구현 메소드 안에서 this 를 사용할 수 있도록 수정.
                    myGridConfig.onItemDblClick.call(this, rowItem);
                }
            };
        }

        // 사용자 정의시 body.onClick 이 없을 경우 설정
        if (!myGridConfig.body.onClick) {
            myGridConfig.body.onClick = function () {
                // 20180625 (이상훈) : tree 를 사용중이 아닐 경우에만 행전체 선택을 실행합니다. tree 일 경우 selectedClear 에서 오류 발생
                if (this.self.config.tree.use) {
                    var prevModified;

                    for (var i = 0; i < this.self.list.length; i++) {
                        if (!this.self.list[i].hasOwnProperty('__modified__')) {
                            this.self.setValue(i, '__modified__', false);
                        }

                        if (i != this.dindex) {
                            prevModified = this.self.list[i]['__modified__'];

                            this.self.setValue(i, '__selected__', false);
                            this.self.setValue(i, '__modified__', prevModified);
                        }
                    }

                    this.self.select(this.dindex);
                } else {
                    // selectedClear : 다중 선택한 후 단일행 클릭시 이전 다중행 선택 해제됨.
                    this.self.select(this.dindex, { selectedClear: true });
                }

                var rowItem = this.list[this.dindex];

                // 바인딩
                axboot.util.bindingTarget(this.self.$target, rowItem);

                if (!ax5.util.isNothing(myGridConfig.onItemClick) && ax5.util.isFunction(myGridConfig.onItemClick)) {
                    var cellInfo = {
                        colIndex: this.colIndex,
                        dindex: this.dindex,
                        doindex: this.doindex,
                        column: this.column,
                        rowIndex: this.rowIndex
                    };

                    // 2018.06.25 (이상훈) : myGridConfig.onItemClick 구현 메소드 안에서 this 를 사용할 수 있도록 수정.
                    //myGridConfig.onItemClick(rowItem, cellInfo, this.self);
                    myGridConfig.onItemClick.call(this, rowItem, cellInfo, this.self);
                }
            };
        }

        if (!myGridConfig.body.onDataChanged) {
            myGridConfig.body.onDataChanged = function () {
                if (!ax5.util.isNothing(myGridConfig.onDataChanged) && ax5.util.isFunction(myGridConfig.onDataChanged)) {
                    // 2018.06.25 (이상훈) : 호출시 메소드 안에서 this 객체가 body.onDataChanged 로 선언할 때와 다름.
                    //myGridConfig.onDataChanged(this.dindex, this.key, this.value, this.item, this.self);

                    // 2018.06.25 (이상훈) : myGridConfig.onDataChanged 구현 메소드 안에서 this 를 사용할 수 있도록 수정.
                    myGridConfig.onDataChanged.call(this, this.dindex, this.key, this.value, this.item, this.self);
                }
            };
        }

        return new ax5.ui.grid(myGridConfig);
    };
}();

//############################################################################################
//# 사용자 정의 그리드 포매터
//############################################################################################

// 개수
ax5.ui.grid.formatter['count'] = function () {
    return this.value + '개';
};

/**
 * Percent (ex. 15%)
 */
ax5.ui.grid.formatter['percent'] = function () {
    return this.value + '%';
};

// 파일 크기
ax5.ui.grid.formatter['fileSize'] = function () {
    return ax5.util.number(this.value, { 'byte': true });
};

ax5.ui.grid.formatter['dateTime'] = function () {
    return this.value != null ? moment(this.value).format(axboot.def.dateTimeFormat) : '';
};

ax5.ui.grid.formatter['date'] = function () {
    return this.value != null ? moment(this.value).format(axboot.def.dateFormat) : '';
};

ax5.ui.grid.formatter['dateMonth'] = function () {
    return this.value != null ? moment(this.value).format(axboot.def.dateMonthFormat) : '';
};

ax5.ui.grid.formatter['yn'] = function () {
    return this.value == 'Y' ? '<span class="label label-success">YES</span>' : '<span class="label label-danger">NO</span>';
};

ax5.ui.grid.formatter["bizno"] = function () {
    var val = (this.value || "").replace(/\D/g, "");
    var regExpPattern = /^([0-9]{3})\-?([0-9]{1,2})?\-?([0-9]{1,5})?.*$/,
        returnValue = val.replace(regExpPattern, function (a, b) {
        var nval = [arguments[1]];
        if (arguments[2]) nval.push(arguments[2]);
        if (arguments[3]) nval.push(arguments[3]);
        return nval.join("-");
    });
    return returnValue;
};

ax5.ui.grid.formatter["phone"] = function () {
    var val = this.value.replace(/\D/g, "");
    var regExpPattern3 = /^([0-9]{3})\-?([0-9]{1,4})?\-?([0-9]{1,4})?\-?([0-9]{1,4})?\-?([0-9]{1,4})?/,
        returnValue = val.replace(regExpPattern3, function (a, b) {
        var nval = [arguments[1]];
        if (arguments[2]) nval.push(arguments[2]);
        if (arguments[3]) nval.push(arguments[3]);
        if (arguments[4]) nval.push(arguments[4]);
        if (arguments[5]) nval.push(arguments[5]);
        return nval.join("-");
    });
    return returnValue;
};

//시간에서 시,분 구분자 표시
ax5.ui.grid.formatter["time"] = function () {
    var val = "";
    if (this.value != null && this.value != "" || this.value == 0) {
        val = this.value.replace(':', '');
        return val.substr(0, 2) + ":" + val.substr(2);
    } else {
        return "";
    }
};

//넘어오는 값이 0일경우 ""으로 치환되어 0비교 추가
ax5.ui.grid.formatter["money"] = function () {
    if (this.value != null && this.value != "" || this.value == 0) {
        return ax5.util.number(this.value, { round: 0, money: true });
    } else {
        return "";
    }
};

//넘어오는 값이 0일경우 ""으로 치환되어 0비교 추가 (면적 포매터)
ax5.ui.grid.formatter["size"] = function () {

    if (this.value != null && this.value != "" || this.value == 0) {
        return ax5.util.number(this.value, { abs: true, round: 2, money: true });
    } else {
        return "";
    }
};

//숮자형 포메터
ax5.ui.grid.formatter["number"] = function () {

    if (this.value != null && this.value != "" || this.value == 0) {
        return ax5.util.number(this.value);
    } else {
        return "";
    }
};
axboot.tabBuilder = function () {
    var defaultTabConfig = {};

    return function (_config) {
        var myTabConfig = $.extend(true, {}, defaultTabConfig, _config);

        myTabConfig.onOpenTab = function () {
            var activeTabPanel = this.activePanel.$target.get(0);

            this.activePanel.$target.find('[data-fit-height-content]').each(function () {
                var $this = $(this);
                var _pHeight = $this.offsetParent().height();
                var name = this.getAttribute("data-fit-height-content");
                var _asideHeight = 0;
                $('[data-fit-height-aside="' + name + '"]').each(function () {
                    _asideHeight += $(this).outerHeight();
                });
                $this.css({ height: _pHeight - _asideHeight });
            });

            myTabConfig.target.ax5layout('reset');

            if (ax5.ui.grid_instance) {
                for (var gi = 0, gl = ax5.ui.grid_instance.length; gi < gl; gi++) {
                    var target = ax5.util.findParentNode(ax5.ui.grid_instance[gi].$target.get(0), function (_el) {
                        return activeTabPanel == _el;
                    });
                    if (target) {
                        ax5.ui.grid_instance[gi].setHeight(ax5.ui.grid_instance[gi].$target.height());
                        ax5.ui.grid_instance[gi].repaint();
                    }
                }
            }

            if (!ax5.util.isNothing(myTabConfig.onChangeTab) && ax5.util.isFunction(myTabConfig.onChangeTab)) {
                var selectedTab = axboot.util.getActiveTab(myTabConfig.target.ax5layout('getActiveTab'));

                myTabConfig.onChangeTab(selectedTab);

                // change 이벤트 발생 후 초기화가 완료된 것으로 간주.
                selectedTab.$target.data('initTab', true);
            }
        };

        return myTabConfig.target.ax5layout(myTabConfig);
    };
}();
axboot.treeBuilder = function () {
    /* http://www.treejs.cn/v3/api.php 를 참고하세요. */

    var defaultTreeSetting = {};

    var treeClass = function treeClass(_target, _setting, _zNodes) {
        this.targetId = "";
        this.$target = null;
        this.setting = {};
        this.zNodes = [];
        var callbackFlag = true;

        this.setData = function (_zNodes) {
            if (typeof _zNodes !== "undefined") this.zNodes = ax5.util.deepCopy(_zNodes);
            $.fn.zTree.init(this.$target, this.setting, this.zNodes);
        };
        this.getData = function () {
            return this.zTree.getNodes();
        };
        this.selectNode = function (_treeNode) {
            this.zTree.selectNode(_treeNode);
        };
        this.cancelSelectedNode = function () {
            this.zTree.cancelSelectedNode();
        };
        this.getSelectedNodes = function () {
            return this.zTree.getSelectedNodes();
        };
        this.editName = function () {
            var nodes = this.zTree.getSelectedNodes();
            if (nodes.length == 0) {
                alert("Please select one node at first...");
                return;
            }
            this.zTree.editName(nodes[0]);
        };
        this.removeNode = function (treeNode) {
            var nodes = this.zTree.getSelectedNodes();
            if (nodes.length == 0) {
                alert("Please select one node at first...");
                return;
            }
            zTree.removeNode(nodes[0], callbackFlag);
        };
        this.addNode = function () {};
        this.convertList2Tree = function (_list, _config) {
            _list = JSON.parse(JSON.stringify(_list));

            var childKey = _config.childKey;
            var parentKey = _config.parentKey;
            var childrenKey = _config.childrenKey || "children";
            var labelKey = _config.labelKey;
            var seq = 0;
            var hashDigit = 3;
            var tree = [];
            var pointer = {};
            for (var i = 0, l = _list.length; i < l; i++) {
                pointer[_list[i][childKey]] = i;
                if (!_list[i][parentKey]) {
                    var item = _list[i];
                    item.pHash = ax5.util.setDigit("0", hashDigit);
                    item.hash = ax5.util.setDigit("0", hashDigit) + "_" + ax5.util.setDigit(seq, hashDigit);

                    var pushItem = {
                        id: item[childKey],
                        name: item[labelKey],
                        label: item[labelKey],
                        pHash: ax5.util.setDigit("0", hashDigit),
                        hash: ax5.util.setDigit("0", hashDigit) + "_" + ax5.util.setDigit(seq, hashDigit),
                        data: $.extend({}, item),
                        __subTreeLength: 0
                    };
                    pushItem[childrenKey] = [];

                    tree.push(pushItem);
                    seq++;
                }
            }
            for (var i = 0, l = _list.length; i < l; i++) {
                if (_list[i][parentKey]) {
                    var item = _list[i];

                    var pItem = _list[pointer[item[parentKey]]];
                    var pHash = pItem["hash"];
                    var pHashs = pHash.split(/_/g);
                    var pTree = tree;
                    var pTreeItem = {};
                    var __subTreeLength = typeof pItem.__subTreeLength !== "undefined" ? pItem.__subTreeLength : 0;

                    pHashs.forEach(function (T, idx) {
                        if (idx > 0) {
                            pTreeItem = pTree[Number(T)];
                            pTree = pTree[Number(T)][childrenKey];
                        }
                    });

                    item[childrenKey] = [];
                    item["pHash"] = pHash;
                    item["hash"] = pHash + "_" + ax5.util.setDigit(__subTreeLength, hashDigit);

                    var pushItem = {
                        name: item[labelKey],
                        label: item[labelKey],
                        pHash: pHash,
                        hash: pHash + "_" + ax5.util.setDigit(__subTreeLength, hashDigit),
                        data: $.extend({}, item)
                    };
                    pushItem[childrenKey] = [];
                    pTree.push(pushItem);

                    if (typeof pItem.__subTreeLength === "undefined") pItem.__subTreeLength = 1;else pItem.__subTreeLength++;

                    pTreeItem.__subTreeLength = pItem.__subTreeLength;
                }
            }
            return tree;
        };

        this.$target = _target;
        if (!this.$target.get(0).id) {
            this.$target.get(0).id = "axboot-tree-" + ax5.getGuid();
        }
        this.targetId = this.$target.get(0).id;
        this.setting = $.extend(true, {}, defaultTreeSetting, _setting);
        if (typeof _zNodes !== "undefined") this.zNodes = ax5.util.deepCopy(_zNodes);

        $.fn.zTree.init(this.$target, this.setting, this.zNodes);
        this.zTree = $.fn.zTree.getZTreeObj(this.targetId);
    };

    return function (_target, _setting, _zNodes) {
        return new treeClass(_target, _setting, _zNodes);
    };
}();
/**
 * @function axboot.uploaderBuilder
 * @param {Object} _config
 */
axboot.uploaderBuilder = function () {
    var defaultUploadConfig = {
        //debug: true,
        form: {
            action: axboot.def.uploader.uploadUrl,
            fileName: 'file'
        },
        viewMode: false,
        multiple: true,
        manualUpload: false,
        progressBox: true,
        progressBoxDirection: 'left',
        onprogress: function onprogress() {
            //console.log('##### onprogress');
        },
        onuploaderror: function onuploaderror() {
            //console.log('##### onuploaderror');

            axboot.util.responseResultMsg(this.error);
        },
        onuploaded: function onuploaded(data) {
            var responseType = axboot.util.getResponseType(data);

            if (responseType == 'validation' && data.errorCount > 0) {
                axboot.util.responseResultMsg(data);
            } else {
                if (ax5.util.isNothing(this.self.getAttachId())) {
                    // 업로드 아이디와 같은 입력 상자에 첨부 아이디를 설정한다.
                    this.self.setAttachId(data['attachId']);
                }

                this.self.isBeforeUploaded = true;
            }
        },
        onuploadComplete: function onuploadComplete() {
            var that = this;

            this.self.loadUploaded(function () {
                that.self.isType = "upload";
                __onComplete(that.self);

                that.self.isBeforeUploaded = false;
            });
        }
    };

    var __downloadFile = function __downloadFile(downloadUrl) {
        if (!ax5.util.isNothing(downloadUrl)) {
            axboot.file.download(downloadUrl);
        }
    };

    var __deleteFile = function __deleteFile(uploader, fileIndex, file, grid) {
        var mask = new ax5.ui.mask();

        axDialog.confirm({
            theme: 'danger',
            title: '삭제확인',
            msg: '선택한 파일을 삭제하시겠습니까?',
            onStateChanged: function onStateChanged() {
                if (this.state === 'open') {
                    mask.open({ theme: 'danger' });
                } else if (this.state === 'close') {
                    mask.close();
                }
            }
        }, function () {
            if (this.key == 'ok') {
                var objectType = axboot.util.getObjectType(uploader);

                if (grid != null) {
                    objectType = axboot.util.getObjectType(grid);
                }

                axboot.command.ajax(axboot.def.uploader.deleteUrl, [{ 'storageId': file.storageId, 'attachId': file.attachId, 'fileSn': file.fileSn }], function (data) {
                    if (data.error) {
                        alert(data.error.message);
                        return;
                    }

                    uploader.loadUploaded(function () {
                        uploader.isType = "delete";
                        __onComplete(uploader);
                    });
                });
            }
        });
    };

    var __onComplete = function __onComplete(uploader) {
        if (uploader.config.hasOwnProperty('onComplete') && ax5.util.getType(uploader.config.onComplete) === 'function') {
            uploader.config.onComplete.call(uploader, {
                'attachId': uploader.getAttachId(),
                'fileCount': uploader.uploadedFiles.length,
                'isBeforeUploaded': uploader.isBeforeUploaded,
                'isType': uploader.isType
            });
        }
    };

    return function (_config) {
        var limitCount = 1;
        var limitCapacity = 0;

        var myUploaderConfig = $.extend(true, {}, defaultUploadConfig, _config);

        var $target = myUploaderConfig.target;
        var targetId = $target.attr('id');
        var storageId = $target.find('input[name=storageId]').val();
        var isUploadedBox = $target.data('isUploadedBox');
        var isDropZone = $target.data('isDropZone');
        var isViewMode = $target.data('isViewMode');
        var uploadedBoxType = $target.data('uploadedBoxType');

        // 저장소 정보 설정
        if (!ax5.util.isNothing(storageId)) {
            axboot.command.ajax(axboot.def.uploader.storageUrl, { 'storageId': storageId }, function (res) {
                limitCount = res['limitCount'];
                limitCapacity = res['limitCapacity'];

                $target.find('[data-file-limit-count]').text(limitCount);
                $target.find('[data-file-limit-capacity]').text(limitCapacity);
            });
        }

        $target.find('[data-file-capacity]').text(ax5.util.number(0, { 'byte': true }));

        // 업로드 제한 개수 설정
        if (myUploaderConfig.hasOwnProperty('limitCount')) {
            limitCount = myUploaderConfig['limitCount'];
        }

        // 파일 업로드 검증 추가
        if (!myUploaderConfig.hasOwnProperty('validateSelectedFiles')) {
            myUploaderConfig.validateSelectedFiles = function () {
                this.self.isBeforeUploaded = false;

                if (this.uploadedFiles.length + this.selectedFiles.length > limitCount) {
                    axDialog.alert('파일 업로드 제한개수는 ' + limitCount + '개 입니다.');
                    return false;
                }

                return true;
            };
        }

        // 파일 드래그 앤 드롭 지원
        if (!myUploaderConfig.hasOwnProperty('dropZone') && isDropZone) {
            myUploaderConfig['dropZone'] = {
                target: $('[data-uploaded-box="' + targetId + '"]')
            };
        }

        // 업로드 박스 표시
        if (isUploadedBox && uploadedBoxType.toUpperCase() === 'DEFAULT' && !myUploaderConfig.hasOwnProperty('uploadedBox')) {
            myUploaderConfig['uploadedBox'] = {
                target: $('[data-uploaded-box="' + targetId + '"]'),
                icon: {
                    'download': '<i class="fa fa-download" aria-hidden="true"></i>',
                    'delete': '<i class="fa fa-minus-circle" aria-hidden="true"></i>'
                },
                columnKeys: {
                    name: 'fileName',
                    type: 'ext',
                    size: 'fileSize',
                    uploadedName: 'saveName',
                    uploadedPath: '',
                    downloadPath: '',
                    previewPath: '',
                    thumbnail: ''
                },
                lang: {
                    supportedHTML5_emptyListMsg: '<div class="text-center" style="padding-top: 30px;">Drop files here or click to upload.</div>',
                    emptyListMsg: '<div class="text-center" style="padding-top: 30px;">Empty of List.</div>'
                },
                onchange: function onchange() {},
                onclick: function onclick() {
                    var that = this;
                    var fileIndex = this.fileIndex;
                    var file = this.uploadedFiles[fileIndex];

                    switch (this.cellType) {
                        case 'delete':
                            __deleteFile(that.self, fileIndex, file);
                            break;
                        case 'download':
                            __downloadFile(file.download);
                            break;
                    }
                }
            };
        }

        var uploader = new ax5.ui.uploader(myUploaderConfig);
        uploader['uploadedGridBox'] = undefined;
        uploader['isBeforeUploaded'] = false;

        // 업로드 박스 타입이 그리드일 경우
        if (isUploadedBox && uploadedBoxType.toUpperCase() === 'GRID') {
            var uploadedGridBox = new ax5.ui.grid({
                target: $('[data-ax5grid="' + targetId + '"]'),
                columns: [{ key: 'fileName', label: '파일명', width: 250, sortable: true }, { key: 'fileSize', label: '파일크기', width: 70, align: 'right', sortable: true,
                    formatter: function formatter() {
                        return ax5.util.number(this.value, { 'byte': true });
                    }
                }, { key: 'ext', label: '확장자', align: 'center', width: 70, sortable: true }, { key: 'createdAt', label: '등록일', align: 'center', width: 140, sortable: true,
                    formatter: function formatter() {
                        return this.value != null ? moment(this.value).format(axboot.def.dateTimeFormat) : '';
                    }
                }, { key: 'download', label: '다운로드', width: 65, align: 'center',
                    formatter: function formatter() {
                        return '<i class="fa fa-download" style="cursor: pointer" aria-hidden="true"></i>';
                    }
                }, { key: 'delete', label: '삭제', width: 50, align: 'center',
                    formatter: function formatter() {
                        return '<i class="fa fa-minus-circle" style="cursor: pointer" aria-hidden="true"></i>';
                    }
                }],
                body: {
                    onClick: function onClick() {
                        this.self.select(this.dindex, { selectedClear: true });

                        if (this.column.key == 'download' && this.item.download) {
                            __downloadFile(this.item.download);
                        } else if (this.column.key == 'delete') {
                            __deleteFile(uploader, this.dindex, this.item, this.self);
                        }
                    }
                },
                page: {
                    display: false
                }
            });

            // 삭제 컬럼 제거
            if (isViewMode) {
                uploadedGridBox.removeColumn(5);
            }

            uploader['uploadedGridBox'] = uploadedGridBox;
        }

        uploader['getStorageId'] = function () {
            var $storageInputBox = this.$target.find('input[name="storageId"]');

            return $storageInputBox.val();
        };

        uploader['getAttachId'] = function () {
            var targetId = this.$target.attr('id');
            var $attachInputBox = this.$target.find('input[name="' + targetId + '"]');

            return $attachInputBox.val();
        };

        uploader['setAttachId'] = function (attachId) {
            var targetId = this.$target.attr('id');
            var $attachInputBox = this.$target.find('input[name="' + targetId + '"]');

            $attachInputBox.val(attachId);

            $attachInputBox = this.$target.find('input[name="attachId"]');
            $attachInputBox.val(attachId);
        };

        uploader['setParams'] = function (params) {
            var targetId = this.$target.attr('id');
            var $paramsInputBox = this.$target.find('input[name="params"]');
            var paramsStr = '';

            if (ax5.util.getType(params) === 'object') {
                paramsStr = JSON.stringify(params);
            }

            $paramsInputBox.val(paramsStr);
        };

        // 파일 업로드 정보 표시
        uploader['loadUploaded'] = function (callback) {
            this.clear();

            if (!ax5.util.isNothing(this.getAttachId())) {
                var that = this;

                axboot.command.ajax(axboot.def.uploader.fileListUrl, { 'storageId': this.getStorageId(), 'attachId': this.getAttachId() }, function (data) {
                    that.setUploadedFiles(data);

                    var totalSize = 0;

                    for (var i = 0; i < data.length; i++) {
                        totalSize += data[i]['fileSize'];
                    }

                    that.$target.find('[data-file-capacity]').text(ax5.util.number(totalSize, { 'byte': true }));
                    that.$target.find('[data-file-count]').text(data.length);

                    if (that.hasOwnProperty('uploadedGridBox') && !ax5.util.isNothing(that.uploadedGridBox)) {
                        that.uploadedGridBox.setData(that.uploadedFiles);
                    }

                    if (!ax5.util.isNothing(callback) && ax5.util.getType(callback) === 'function') {
                        callback.call(that);
                    }
                });
            } else {
                this.$target.find('[data-file-capacity]').text(ax5.util.number(0, { 'byte': true }));
                this.$target.find('[data-file-count]').text(0);

                if (!ax5.util.isNothing(callback) && ax5.util.getType(callback) === 'function') {
                    callback.call(that);
                }
            }
        };

        return uploader;
    };
}();
//############################################################################################
//# axboot.command
//############################################################################################

axboot.command = {
    'ajax': function ajax(url, data, _callback, isUnconditionalCallback) {
        // 20180614 (이상훈) : 순수 array 형 파라미터를 사용할 경우 문제 발생으로, data 파라미터가 array 일경우 object map 으로 머지기능 삭제.
        /*
        var tempData = {};
         if (ax5.util.getType(data) === 'array') {
            for (var i = 0; i < data.length; i++) {
                tempData = $.extend(true, tempData, data[i]);
            }
        } else if (ax5.util.getType(data) === 'object') {
            tempData = $.extend(true, tempData, data);
        }
        */

        // data 값이 없을 경우 빈 object 로 전송한다.
        if (ax5.util.isNothing(data)) {
            data = {};
        }

        axboot.ajax({
            url: url,
            data: JSON.stringify(data),
            callback: function callback(res) {
                if (!ax5.util.isNothing(_callback) && ax5.util.getType(_callback) === 'function') {
                    _callback.call(this, res);
                }
            },
            unconditionalCallback: isUnconditionalCallback
        });
    },
    'get': function get(obj, options, _callback2) {
        var ajaxConfig = axboot.util.getCommandOptionsToAjaxConfig(options);
        var objList = [];

        if (ax5.util.getType(obj) === 'object') {
            objList.push(obj);
        } else if (ax5.util.getType(obj) === 'array') {
            objList = obj;
        }

        for (var i = 0; i < objList.length; i++) {
            if (objList[i].target.name == 'grid') {
                ajaxConfig['data'] = $.extend(true, {}, ajaxConfig['data'], objList[i].getPageData());
            }
        }

        axboot.ajax({
            url: ajaxConfig['url'],
            data: JSON.stringify(ajaxConfig['data']),
            callback: function callback(res) {
                if (!ax5.util.isNothing(_callback2) && ax5.util.isFunction(_callback2)) {
                    _callback2.call(this, res);
                } else {
                    for (var i = 0; i < objList.length; i++) {
                        var data = ax5.util.deepCopy(res);

                        objList[i].setData(data);

                        // 바인딩된 폼을 초기화 시켜준다.
                        var aryBindingTarget = axboot.util.getBindingTargets(objList[i].target.$target);

                        for (var x = 0; x < aryBindingTarget.length; x++) {
                            if (fnObj.hasOwnProperty(aryBindingTarget[x])) {
                                fnObj[aryBindingTarget[x]].disable();
                                fnObj[aryBindingTarget[x]].setData(fnObj[aryBindingTarget[x]].getDefaultData());
                            }
                        }
                    }
                }
            }
        });
    },
    'save': function save(obj, options, callback) {
        var mask = new ax5.ui.mask();
        var objectType = axboot.util.getObjectType(obj);

        // todo : 다중 객체가 들어올 경우의 처리
        if (ax5.util.getType(obj) === 'object') {} else if (ax5.util.getType(obj) === 'array') {}

        var ajaxConfig = {
            'saveAll': false
        };

        if (ax5.util.getType(options) === 'string') {
            ajaxConfig['url'] = options;
        } else if (ax5.util.getType(options) === 'object') {
            ajaxConfig = $.extend(true, {}, ajaxConfig, options);
        }

        // GRID 일 경우 처리
        if (objectType == 'GRID') {
            var list = obj.getData();

            var commandList = [];
            var message = '';

            // 전체 저장일 경우 : rowState 를 'U' (수정) 으로 변경한다.
            if (ajaxConfig['saveAll']) {
                for (var i = 0; i < list.length; i++) {
                    list[i]['rowState'] = 'U';
                    commandList.push(list[i]);
                }
            } else {
                for (var i = 0; i < list.length; i++) {
                    if (axboot.util.isSaveRow(list[i])) {

                        list[i]['rowState'] = axboot.util.getRowState(list[i]);
                        commandList.push(list[i]);
                    }
                }
            }
            // 저장시킬 목록이 존재할 경우
            if (commandList.length > 0) {
                ajaxConfig['data'] = commandList;

                if (message != '') {
                    axDialog.confirm({
                        theme: 'danger',
                        title: '알림!',
                        msg: message,
                        onStateChanged: function onStateChanged() {
                            if (this.state === 'open') {
                                mask.open({ theme: 'danger' });
                            } else if (this.state === 'close') {
                                mask.close();
                            }
                        }
                    }, function () {
                        if (this.key == 'ok') {
                            axboot.ajax({
                                url: ajaxConfig['url'],
                                data: JSON.stringify(ajaxConfig['data']),
                                callback: callback
                            });
                        }
                    });
                } else {
                    axboot.ajax({
                        url: ajaxConfig['url'],
                        data: JSON.stringify(ajaxConfig['data']),
                        callback: callback
                    });
                }
            } else {
                axDialog.alert({
                    title: '알림',
                    msg: '저장 대상이 없습니다.'
                });
            }
        }
        // 폼 일 경우 처리
        else if (objectType == 'FORM') {
                axboot.ajax({
                    url: ajaxConfig['url'],
                    data: JSON.stringify(obj.getData()),
                    callback: callback
                });
            } else {
                // 20190422 (이상훈) : Object 객체를 이용하여 GRID 데이터를 넘길 경우 caller.gird 를 설정해줘야 한다.
                // !!caller.grid.getData 를 직접 설정할 경우 objectType 을 알수 없음.
                /*
                var objParam = {};
                objParam.crqfcList    = caller.crqfcGrid;
                objParam.lantraList   = caller.lantraGrid;
                objParam.ovseaExpList = caller.ovseaExpGrid;
                objParam.actHstList   = caller.acthstGrid;
                */

                for (var key in obj) {
                    objectType = axboot.util.getObjectType(obj[key]);

                    if (objectType === 'GRID') {
                        var list = obj[key].getData();

                        for (var i = 0; i < list.length; i++) {
                            if (axboot.util.isSaveRow(list[i])) {
                                list[i]['rowState'] = axboot.util.getRowState(list[i]);
                            }
                        }

                        obj[key] = list;
                    }
                }

                axboot.ajax({
                    url: ajaxConfig['url'],
                    data: JSON.stringify(obj),
                    callback: callback
                });
            }
    },
    'remove': function remove(obj, options, callback) {
        var objectType = axboot.util.getObjectType(obj);

        var defaultParam = {};
        var ajaxConfig = {};
        var message = '';
        var selectedCount = 0;

        // todo : 다중 객체가 들어올 경우의 처리
        if (ax5.util.getType(obj) === 'object') {} else if (ax5.util.getType(obj) === 'array') {}

        if (objectType == 'GRID') {
            selectedCount = obj.getData('selected').length;
        }

        if (ax5.util.getType(options) === 'string') {
            ajaxConfig['url'] = options;
        } else if (ax5.util.getType(options) === 'object') {
            ajaxConfig = $.extend(true, {}, ajaxConfig, options);
        }

        if (selectedCount == 0) {
            axDialog.alert({
                title: '알림',
                msg: '삭제 대상이 없습니다.'
            });

            return;
        }

        var hasAddRow = false;
        var list = obj.getData();
        var commandList = [];
        var rtnMessage = '';

        for (var i = list.length - 1; i >= 0; i--) {
            /* 2010.12.06 (이상훈) : 신규 입력행이면서 선택되었을 경우에만 확인 */
            if (axboot.util.getRowState(list[i]) == 'I' && axboot.util.isSelectedRow(list[i])) {
                hasAddRow = true;
                break;
            }
        }

        if (hasAddRow) {
            axDialog.confirm({
                theme: 'danger',
                title: '삭제 알림!',
                msg: '신규 입력된 항목중 선택된 항목을 삭제 하시겠습니까?',
                width: 400
            }, function () {
                if (this.key == 'ok') {
                    for (var i = list.length - 1; i >= 0; i--) {
                        if (list[i]['__created__'] && list[i]['__selected__']) {
                            obj.target.deleteRow(i);
                        }
                    }

                    obj.target.focus('END');
                }
            });
        } else {
            var mask = new ax5.ui.mask();
            var targetValue = '';

            if (objectType == 'GRID') {
                var columns = obj.target.columns;
                var targetColumnKeys = [];
                var targetColumnValues = [];
                var messageLimitCount = 5;
                var selectedData;
                var hasCommandMessage = false;

                // 재귀호출
                var commandMessageFind = function commandMessageFind(columns) {
                    for (var i = 0; i < columns.length; i++) {
                        if (columns[i].hasOwnProperty('commandMessage') && columns[i]['commandMessage'] == 'remove') {
                            targetColumnKeys.push(columns[i]['key']);
                            hasCommandMessage = true;
                        }

                        if (columns[i].hasOwnProperty('columns')) {
                            commandMessageFind(columns[i]['columns']);
                        }
                    }
                };

                // 메시지 출력 대상 값이 있는지 확인한다.
                /*
                for (var i = 0; i < columns.length; i++) {
                    if (columns[i].hasOwnProperty('commandMessage') && columns[i]['commandMessage'] == 'remove') {
                        targetColumnKeys.push(columns[i]['key']);
                        hasCommandMessage = true;
                    }
                }
                */

                commandMessageFind(columns);

                if (hasCommandMessage) {
                    for (var i = 0; i < selectedCount; i++) {
                        if (i > messageLimitCount - 1) {
                            break;
                        }

                        targetValue = '';

                        for (var j = 0; j < targetColumnKeys.length; j++) {
                            selectedData = obj.getData('selected')[i][targetColumnKeys[j]];

                            if (ax5.util.isNothing(selectedData)) {
                                selectedData = '';
                            }

                            if (j > 0 && !ax5.util.isNothing(selectedData)) {
                                targetValue += ', ';
                            }

                            targetValue += selectedData;
                        }

                        targetColumnValues.push(targetValue);
                    }
                }
            }

            message = ' 선택된 <font color="red"><b>' + selectedCount + '</b></font> 개의 항목을 삭제하시겠습니까?';
            if (rtnMessage != '') message = rtnMessage + '<br />' + message;

            for (var i = 0; i < targetColumnValues.length; i++) {
                message += '<br />';
                message += '[' + targetColumnValues[i] + ']';
            }

            if (hasCommandMessage && selectedCount - messageLimitCount > 0) {
                message += '<br />';
                message += '외 <font color="red"><b>' + (selectedCount - messageLimitCount) + '</b></font> 개';
            }

            axDialog.confirm({
                theme: 'danger',
                title: '삭제 알림!',
                msg: message,
                onStateChanged: function onStateChanged() {
                    if (this.state === 'open') {
                        mask.open({ theme: 'danger' });
                    } else if (this.state === 'close') {
                        mask.close();
                    }
                }
            }, function () {
                if (this.key == 'ok') {
                    for (var i = list.length - 1; i >= 0; i--) {
                        if (axboot.util.isSelectedRow(list[i])) {
                            list[i]['rowState'] = 'R';
                            commandList.push(list[i]);
                        }
                    }

                    if (commandList.length > 0) {
                        ajaxConfig['data'] = commandList;

                        axboot.ajax({
                            url: ajaxConfig['url'],
                            data: JSON.stringify(ajaxConfig['data']),
                            callback: callback
                        });
                    }
                }
            });
        }
    },
    'select': function select(obj, options, callback) {
        var objectType = axboot.util.getObjectType(obj);

        var defaultParam = {};
        var ajaxConfig = {};
        var message = '';
        var selectedCount = 0;

        // todo : 다중 객체가 들어올 경우의 처리
        if (ax5.util.getType(obj) === 'object') {} else if (ax5.util.getType(obj) === 'array') {}

        if (objectType == 'GRID') {
            selectedCount = obj.getData('selected').length;
        }

        if (ax5.util.getType(options) === 'string') {
            ajaxConfig['url'] = options;
        } else if (ax5.util.getType(options) === 'object') {
            ajaxConfig = $.extend(true, {}, ajaxConfig, options);
        }

        if (selectedCount == 0) {
            axDialog.alert({
                title: '알림',
                msg: '선택 대상이 없습니다.'
            });

            return;
        }

        var hasAddRow = false;
        var list = obj.getData();
        var commandList = [];
        var rtnMessage = '';

        for (var i = list.length - 1; i >= 0; i--) {
            if (axboot.util.getRowState(list[i]) == 'I') {
                hasAddRow = true;
                break;
            }
        }

        if (hasAddRow) {
            axDialog.confirm({
                theme: 'danger',
                title: '삭제 알림!',
                msg: '신규 입력된 항목중 선택된 항목을 삭제 하시겠습니까?',
                width: 400
            }, function () {
                if (this.key == 'ok') {
                    for (var i = list.length - 1; i >= 0; i--) {
                        if (list[i]['__created__'] && list[i]['__selected__']) {
                            obj.target.deleteRow(i);
                        }
                    }

                    obj.target.focus('END');
                }
            });
        } else {
            var mask = new ax5.ui.mask();
            var targetValue = '';

            if (objectType == 'GRID') {
                var columns = obj.target.columns;
                var targetColumnKeys = [];
                var targetColumnValues = [];
                var messageLimitCount = 5;
                var selectedData;
                var hasCommandMessage = false;

                // 재귀호출
                var commandMessageFind = function commandMessageFind(columns) {
                    for (var i = 0; i < columns.length; i++) {
                        if (columns[i].hasOwnProperty('commandMessage') && columns[i]['commandMessage'] == 'select') {
                            targetColumnKeys.push(columns[i]['key']);
                            hasCommandMessage = true;
                        }

                        if (columns[i].hasOwnProperty('columns')) {
                            commandMessageFind(columns[i]['columns']);
                        }
                    }
                };

                commandMessageFind(columns);

                if (hasCommandMessage) {
                    for (var i = 0; i < selectedCount; i++) {
                        if (i > messageLimitCount - 1) {
                            break;
                        }

                        targetValue = '';

                        for (var j = 0; j < targetColumnKeys.length; j++) {
                            selectedData = obj.getData('selected')[i][targetColumnKeys[j]];

                            if (ax5.util.isNothing(selectedData)) {
                                selectedData = '';
                            }

                            if (j > 0 && !ax5.util.isNothing(selectedData)) {
                                targetValue += ', ';
                            }

                            targetValue += selectedData;
                        }

                        targetColumnValues.push(targetValue);
                    }
                }
            }

            message = rtnMessage + '선택된 <font color="red"><b>' + selectedCount + '</b></font> 개의 항목을 등록하시겠습니까?';

            for (var i = 0; i < targetColumnValues.length; i++) {
                message += '<br />';
                message += '[' + targetColumnValues[i] + ']';
            }

            if (hasCommandMessage && selectedCount - messageLimitCount > 0) {
                message += '<br />';
                message += '외 <font color="red"><b>' + (selectedCount - messageLimitCount) + '</b></font> 개';
            }

            axDialog.confirm({
                theme: 'danger',
                title: '알림!',
                msg: message,
                onStateChanged: function onStateChanged() {
                    if (this.state === 'open') {
                        mask.open({ theme: 'danger' });
                    } else if (this.state === 'close') {
                        mask.close();
                    }
                }
            }, function () {
                if (this.key == 'ok') {
                    for (var i = list.length - 1; i >= 0; i--) {
                        if (axboot.util.isSelectedRow(list[i])) {
                            list[i]['rowState'] = 'S';
                            commandList.push(list[i]);
                        }
                    }

                    if (commandList.length > 0) {
                        ajaxConfig['data'] = commandList;

                        axboot.ajax({
                            url: ajaxConfig['url'],
                            data: JSON.stringify(ajaxConfig['data']),
                            callback: callback
                        });
                    }
                }
            });
        }
    }
};

//############################################################################################
//# axboot.file
//############################################################################################

axboot.file = function () {
    var download = function download(url, data, callback) {
        $.fileDownload(url, {
            httpMethod: 'GET',
            data: data,
            prepareCallback: function prepareCallback(url) {
                axAJAXMask.open();
            },
            abortCallback: function abortCallback(url) {
                axAJAXMask.close(300);
            },
            successCallback: function successCallback(url) {
                axAJAXMask.close(300);

                if (!ax5.util.isNothing(callback) && ax5.util.getType(callback) === 'function') {
                    callback.call(this);
                }
            },
            failCallback: function failCallback(responseHtml, url, error) {
                axDialog.alert('File download failed!');
                axAJAXMask.close(300);
            }
        });
    };

    return {
        'download': download
    };
}();

//############################################################################################
//# axboot.initView
//############################################################################################

axboot.initView = function () {
    // 우측 상단 공통버튼 초기화
    var __initPageButton = function __initPageButton(fnObj) {
        fnObj['pageButtonView'] = axboot.viewExtend({
            initView: function initView() {
                axboot.buttonClick(this, 'data-page-btn', {});

                /*
                axboot.buttonClick(this, 'data-page-btn', {
                    'search' : function () {
                        ACTIONS.dispatch(ACTIONS.search);
                    },
                    'add' : function () {
                        ACTIONS.dispatch(ACTIONS.add);
                    },
                    'save' : function () {
                        ACTIONS.dispatch(ACTIONS.save);
                    },
                    'remove' : function () {
                        ACTIONS.dispatch(ACTIONS.remove);
                    }
                });
                */
            }
        });
    };

    // 폼 초기화
    var __initFormView = function __initFormView(fnObj) {
        $('form').each(function (index, element) {
            var formId = $(element).attr('id');

            if (!ax5.util.isNothing(formId)) {
                // Form init
                var objForm = axboot.viewExtend(axboot.formView, {
                    getDefaultData: function getDefaultData() {
                        return $.extend({}, axboot.formView.defaultData, {});
                    },
                    initView: function initView() {
                        this.target = $(element);
                        this.model = new ax5.ui.binder();
                        this.model.setModel(this.getDefaultData(), this.target);
                        this.modelFormatter = new axboot.modelFormatter(this.model);

                        this.initBinding();
                        this.initEvent();
                    },
                    initBinding: function initBinding() {
                        // 바인딩 타겟 목록
                        var aryBindingTarget = axboot.util.getBindingTargets(this.target);
                        var that = this;

                        for (var i = 0; i < aryBindingTarget.length; i++) {
                            if (fnObj.hasOwnProperty(aryBindingTarget[i])) {
                                var $targetObject = fnObj[aryBindingTarget[i]].target;

                                // key event 바인딩
                                this.target.find(':input').on('keyup change click', function () {
                                    var axPath = $(this).data('axPath');

                                    if (!ax5.util.isNothing(axPath)) {
                                        var selectedIndex = -1;
                                        var selectedDataIndexs = $targetObject.selectedDataIndexs;

                                        if (selectedDataIndexs.length > 0) {
                                            selectedIndex = selectedDataIndexs[selectedDataIndexs.length - 1];
                                            $targetObject.setValue(selectedIndex, axPath, $(this).val());

                                            if ($(this).is('select')) {
                                                $targetObject.setValue(selectedIndex, $(this).data('axPathText'), $(this).find('option:selected').text());
                                            }

                                            that.bindEvent();
                                        }
                                    }
                                });
                            }
                        }
                    },
                    initEvent: function initEvent() {},
                    bindEvent: function bindEvent() {},
                    clear: function clear() {
                        this.model.setModel(this.getDefaultData());
                        this.modelFormatter = new axboot.modelFormatter(this.model);
                    },
                    setData: function setData(data) {
                        if (typeof data === 'undefined') {
                            data = this.getDefaultData();
                        }

                        data = $.extend({}, data);

                        this.setModelData(data);

                        this.model.setModel(data);
                        this.modelFormatter.formatting();

                        this.setDataFinished(data);
                    },
                    setModelData: function setModelData(data) {},
                    setDataFinished: function setDataFinished(data) {}
                });

                fnObj[formId] = $.extend(true, {}, objForm, fnObj[formId]);
            }
        });
    };

    // initView 존재 객체에 대한 호출
    var __executeInit = function __executeInit(fnObj) {
        for (var obj in fnObj) {
            if (fnObj[obj].hasOwnProperty('initView') && typeof fnObj[obj]['initView'] === 'function') {
                fnObj[obj].initView();
            }
        }
    };

    var __initSearchViewEnter = function __initSearchViewEnter() {
        $('[data-ax-view-type="search"]').each(function () {
            $(this).find(':input').on('keydown', function (event) {
                if (event.keyCode == 13) {
                    ACTIONS.dispatch(ACTIONS.search);
                    event.preventDefault();
                }
            });
        });
    };

    return function (fnObj) {
        __initPageButton(fnObj);
        __initFormView(fnObj);
        __executeInit(fnObj);
        __initSearchViewEnter();
    };
}();

//############################################################################################
//# axboot.parent
//############################################################################################

axboot.parent = function () {
    var action = function action(_action2, data) {
        if (ax5.util.isNothing(this.getFrame())) {
            this.getFrame().ACTIONS.dispatch(this.getFrame().ACTIONS[_action2], data);
        }
    };

    var getFrame = function getFrame() {
        var parentFrame;

        if (window.parent != window) {
            parentFrame = window.parent;
        }

        return parentFrame;
    };

    return {
        'action': action,
        'getFrame': getFrame
    };
}();

//############################################################################################
//# axboot.validator
//############################################################################################

String.prototype.format = function () {
    var str = this;
    for (var i = 0; i < arguments.length; i++) {
        var reg = new RegExp('\\{' + i + '\\}', 'gm');
        str = str.replace(reg, arguments[i]);
    }

    return str;
};

String.prototype.trim = function () {
    return this.replace(/(^\s*)|(\s*$)/gi, '');
};

String.prototype.startsWith = function (str) {
    if (this.length < str.length) {
        return false;
    }

    return this.indexOf(str) == 0;
};

String.prototype.endsWith = function (str) {
    if (this.length < str.length) {
        return false;
    }

    return this.lastIndexOf(str) + str.length == this.length;
};

axboot.validator = function () {
    var __messageMap = {
        required: '{0} 는(은) 필수 입력항목입니다.',
        length: '{0} 는(은) {1}자로 입력해야 합니다.',
        maxLength: '{0} 는(은) 최소 {1}자 이하로 입력해야합니다.',
        minLength: '{0} 는(은) 최소 {1}자 이상으로 입력해야합니다.',
        max: '{0} 는(은) 최대 {1}까지만 입력가능합니다.',
        min: '{0} 는(은) 최소 {1} 이상 입력해야합니다.',
        number: '{0} 는(은) 숫자만 입력가능합니다.',
        alphaNumeric: '{0} 는(은) 알파벳과 숫자만 입력가능합니다.',
        email: '{0} 주소 형식이 잘못되었습니다.'
    };

    var __validateFunctionMap = {
        required: function required(value, ruleMap) {
            var message = '';

            if (value === undefined) {
                value = '';
            } else if (typeof value === 'string') {
                value = value.replace(/^\s+|\s+$/g, '');
            }

            if (ax5.util.isNothing(value)) {
                message = __messageMap.required.format(ruleMap['title']);
            }

            return __ruleMessage(message);
        },
        length: function length(value, ruleMap) {
            var message = '';
            var length = 0;

            if (!ax5.util.isNothing(value) && String(value).length != ruleMap['value']) {
                message = __messageMap.length.format(ruleMap['title'], ruleMap['value']);
            }

            return __ruleMessage(message);
        },
        maxLength: function maxLength(value, ruleMap) {

            var message = '';

            if (!ax5.util.isNothing(value) && String(value).length > ruleMap['value']) {
                message = __messageMap.maxLength.format(ruleMap['title'], ruleMap['value']);
            }

            return __ruleMessage(message);
        },
        minLength: function minLength(value, ruleMap) {
            var message = '';

            if (!ax5.util.isNothing(value) && String(value).length < ruleMap['value']) {
                message = __messageMap.minLength.format(ruleMap['title'], ruleMap['value']);
            }

            return __ruleMessage(message);
        },
        max: function max(value, ruleMap) {
            var message = '';

            if (parseFloat(value) > ruleMap['value']) {
                message = __messageMap.max.format(ruleMap['title'], ruleMap['value']);
            }

            return __ruleMessage(message);
        },
        min: function min(value, ruleMap) {
            var message = '';

            if (parseInt(value) < ruleMap['value']) {
                message = __messageMap.min.format(ruleMap['title'], ruleMap['value']);
            }

            return __ruleMessage(message);
        },
        number: function number(value, ruleMap) {
            var message = '';

            var pattern = /^\d+$/;

            if (!ax5.util.isNothing(value) && !pattern.test(value)) {
                message = __messageMap.number.format(ruleMap['title']);
            }

            return __ruleMessage(message);
        },
        alphaNumeric: function alphaNumeric(value, ruleMap) {
            var message = '';

            var pattern = /^[0-9a-zA-Z]+$/;

            if (!ax5.util.isNothing(value) && !value.match(pattern)) {
                message = __messageMap.alphaNumeric.format(ruleMap['title']);
            }

            return __ruleMessage(message);
        },
        email: function email(value, ruleMap) {
            var message = '';

            var pattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (!ax5.util.isNothing(value) && !pattern.test(value)) {
                message = __messageMap.email.format(ruleMap['title']);
            }

            return __ruleMessage(message);
        },
        userFunc: function userFunc(value, ruleMap, data) {
            var message = '';

            if (ax5.util.isFunction(ruleMap['value'])) {
                return ruleMap['value'].call(this, value, ruleMap, data);
            } else {
                return __ruleMessage('');
            }
        }
    };

    var __ruleMessage = function __ruleMessage(message) {
        /*
        var objResult = {
            result  : result
           ,message : message
        };
        */

        return message;
    };

    var __makeCompareValue = function __makeCompareValue(data, columns) {
        var delimiter = '__';
        var tempValue = '';
        var hasValue = false;

        if (!ax5.util.isNothing(columns)) {
            for (var k = 0; k < columns.length; k++) {
                tempValue += columns[k] + ':';

                if (!ax5.util.isNothing(data[columns[k]])) {
                    tempValue += data[columns[k]];
                    hasValue = true;
                }

                if (k < columns.length - 1) {
                    tempValue += delimiter;
                }
            }
        }

        return {
            'hasValue': hasValue,
            'value': tempValue
        };
    };

    var __validateMessage = function __validateMessage(validationMappings, data) {
        var functionMap = {};
        var messageArray = new Array();
        var result;

        for (var validKey in validationMappings) {
            functionMap = validationMappings[validKey];

            // 대상 입력항목이 있을 경우
            //if (data.hasOwnProperty(validKey)) {
            for (var functionKey in functionMap) {
                result = __validateFunctionMap[functionKey].call(this, data[validKey], functionMap[functionKey], data);

                if (!ax5.util.isNothing(result)) {
                    messageArray.push(result);
                }
            }
            //}
        }

        return messageArray;
    };

    var validate = function validate(obj, validationRule) {
        var result = true;

        var gridList = obj.getData();
        var gridData = {};
        var columns = obj.target.columns;

        var messageArray = new Array();
        var resultArray = new Array();
        var messageLimitCount = 10;

        var objectType = axboot.util.getObjectType(obj);

        // GRID 유효성 검증
        if (objectType == 'GRID') {
            // 중복 데이터 처리
            if (!ax5.util.isNothing(validationRule['duplicate'])) {
                var saveValues = [];
                var duplicateColumns = validationRule['duplicate']['columns'];

                var duplicateIndex = -1;
                var hasDuplicate = false;
                var compareValue;

                // 입력된 데이터에 대한 비교값 생성
                for (var i = 0; i < gridList.length; i++) {
                    //if (axboot.util.getRowState(gridList[i]) == 'I') {
                    if (axboot.util.isSaveRow(gridList[i])) {
                        compareValue = __makeCompareValue(gridList[i], duplicateColumns);

                        if (compareValue['hasValue']) {
                            saveValues.push({ 'rowIndex': i, 'value': compareValue['value'] });
                        }
                    }
                }

                for (var i = 0; i < saveValues.length; i++) {
                    for (var k = 0; k < gridList.length; k++) {
                        if (k != saveValues[i]['rowIndex']) {
                            compareValue = __makeCompareValue(gridList[k], duplicateColumns);

                            if (saveValues[i]['value'] == compareValue['value']) {
                                duplicateIndex = saveValues[i]['rowIndex'];
                                hasDuplicate = true;
                                break;
                            }
                        }
                    }
                }

                if (hasDuplicate) {
                    resultArray.push({ 'rowIndex': duplicateIndex, 'message': '중복된 데이터가 존재합니다.', 'rowState': axboot.util.getRowState(gridList[duplicateIndex]) });
                }
            }

            // 데이터 유효성 검증
            if (!ax5.util.isNothing(validationRule['rules'])) {
                for (var i = 0; i < gridList.length; i++) {
                    gridData = gridList[i];

                    if (axboot.util.isSaveRow(gridData)) {
                        messageArray = __validateMessage(validationRule['rules'], gridData);

                        for (var k = 0; k < messageArray.length; k++) {
                            resultArray.push({ 'rowIndex': i, 'message': messageArray[k], 'rowState': axboot.util.getRowState(gridData) });
                        }
                    }
                }
            }
        }
        // 폼 유효성 검증
        else if (objectType == 'FORM') {
                if (!ax5.util.isNothing(validationRule['rules'])) {
                    messageArray = __validateMessage(validationRule['rules'], obj.getData());

                    for (var k = 0; k < messageArray.length; k++) {
                        resultArray.push({ 'rowIndex': -1, 'message': messageArray[k], 'rowState': '' });
                    }
                }
            }

        // 메시지 출력 처리
        if (resultArray.length > 0) {
            var errorMessage = '';

            for (var i = 0; i < resultArray.length; i++) {
                // 그리드일 경우 오류 발생 행 정보 추가
                if (objectType == 'GRID') {
                    errorMessage += '[' + (resultArray[i]['rowIndex'] + 1) + '행] ';
                }

                errorMessage += resultArray[i]['message'] + '\n';

                if (i >= messageLimitCount - 1 && resultArray.length - messageLimitCount > 0) {
                    errorMessage += '외 <b><font color="red">' + (resultArray.length - messageLimitCount) + '개</font></b> 의 입력오류 입니다.';
                    break;
                }
            }

            result = false;
        }

        var alert = function alert() {
            if (!result) {
                axDialog.alert({
                    theme: 'danger',
                    title: '입력오류 !',
                    msg: errorMessage,
                    width: 500
                }, function () {
                    var objectType = axboot.util.getObjectType(obj);

                    if (objectType == 'GRID') {
                        var rowIndex = resultArray[0]['rowIndex'];
                        var rowItem = obj.target.getList()[rowIndex];

                        // 20180625 (이상훈) : tree 를 사용중이 아닐 경우에만 행전체 선택을 실행합니다. tree 일 경우 selectedClear 에서 오류 발생
                        if (obj.target.config.tree.use) {
                            obj.target.select(rowIndex);
                        } else {
                            obj.target.select(rowIndex, { selectedClear: true });
                        }

                        axboot.util.bindingTarget(obj.target.$target, rowItem);
                    }
                });
            }

            return result;
        };

        return {
            result: result,
            messages: resultArray,
            alert: alert
        };
    };

    return {
        //'duplicate' : duplicate,
        'validate': validate
    };
}();

/**
 * commonView
 * @Object {Object} axboot.commonView
 */
axboot.commonView = {};

/**
 * 1, 2를 믹스한 새로운 오브젝트를 반환
 * @param _obj1
 * @param _obj2
 */
axboot.extend = function (_obj1, _obj2) {
    return $.extend({}, _obj1, _obj2);
};
axboot.viewExtend = function (_obj1, _obj2) {
    if (typeof _obj2 === "undefined") {
        return $.extend({}, axboot.commonView, _obj1);
    } else {
        return $.extend({}, _obj1, _obj2);
    }
};

/**
 * 페이지에서 사용하는
 * @method axboot.actionExtend
 * @param {Object} [_actionThis]
 * @param {Object} _action
 * @example
 * ```js
 *
 * // ACTION 이름은 키로 사용하고 dispatch에서 처리하는 방식.
 * var ACTION = axboot.actionExtend(fnObj, {
 *  PAGE_SEARCH: "PAGE_SEARCH",
 *  dispatch: function(caller, act, data){
 *      switch (act) {
 *          case ACTIONS.PAGE_SEARCH:
 *              // call view method
 *          break;
 *          default
 *              return false;
 *      }
 *  }
 * });
 *
 * // ACTION 이름에 함수를 구현하는 방식
 * var ACTION = axboot.actionExtend(fnObj, {
 *  PAGE_SEARCH: function(caller, act, data){
 *
 *  },
 *  dispatch: function(caller, act, data){
 *      var result = ACTIONS.exec(caller, act, data);
 *      if(result != "error"){
 *          return result;
 *      } else {
 *          return false;
 *      }
 *  }
 * });
 *
 * // 액션의 실행
 * fnObj.sampleView = axboot.viewExtend({
 *  initView: function(){
 *      ACTIONS.dispatch(ACTIONS.PAGE_SEARCH);
 *  }
 * });
 * ```
 */
axboot.actionExtend = function () {
    return function (_actionThis, _action) {
        var myAction = {};

        // 액션 명령어는 수집하여 담기
        for (var k in _action) {
            if (ax5.util.isString(_action[k])) {
                myAction[k] = _action[k];
            } else if (ax5.util.isFunction(_action[k])) {
                myAction[k] = k;
                myAction["__EXEC__" + k] = _action[k];
            }
        }

        if ("dispatch" in _action) {
            myAction["page_dispatch"] = _action["dispatch"];
        } else {
            myAction["page_dispatch"] = function (caller, act, data) {
                var result = ACTIONS.exec(caller, act, data);

                if (result != 'error') {
                    return result;
                } else {
                    return false;
                }
            };
        }

        myAction["exec"] = function (caller, act, data) {
            if (_action[act]) {
                return _action[act].call(caller, caller, act, data);
            } else {
                return "error";
            }
        };
        myAction["dispatch"] = function () {
            var fnArgs = [];

            fnArgs = ax5.util.toArray(arguments);

            if (ax5.util.isString(fnArgs[0])) {
                // 첫번째 아규먼트가 문자열이라면. action 이름이 왔다고 보자.
                // 첫번째 아규먼트에 _actionThis 삽입
                fnArgs.splice(0, 0, _actionThis);
            }
            return myAction["page_dispatch"].apply(_actionThis, fnArgs);
        };

        return myAction;
    };
}();

/**
 * formView
 * @Object {Object} axboot.formView
 */
axboot.formView = {
    getFormData: function getFormData() {
        return axboot.util.getFormToParam(this.target);
    },
    getData: function getData() {
        // ToDo : model 기준으로 변경
        //return this.model.model;
        //return axboot.util.getFormToParam(this.target);
        // input 에서 enter key 를 눌렀을 경우 model 이 바인딩이 안됨.
        return axboot.extend(this.model.model, axboot.util.getFormToParam(this.target));
    },
    getValue: function getValue(dataPath) {
        var value = this.model.get(dataPath);

        if (ax5.util.isNothing(value)) {
            value = '';
        }

        return value;
    },
    setValue: function setValue(dataPath, value) {
        this.model.set(dataPath, value);
    },
    clear: function clear() {
        this.model.setModel(this.getDefaultData());
        $('[data-ax5formatter]').ax5formatter('formatting');
    },
    disable: function disable() {
        //this.model.setModel(this.getDefaultData());
        //$('[data-ax5formatter]').ax5formatter('formatting');

        this.target.find(':input').attr('disabled', true);
    },
    enable: function enable() {
        //this.model.setModel(this.getDefaultData());
        //$('[data-ax5formatter]').ax5formatter('formatting');

        this.target.find(':input').attr('disabled', false);
    }
};

/**
 * formView.defaultData
 * @Object {Object} axboot.formView.defaultData
 */
axboot.formView.defaultData = {};
/**
 * gridView
 * @Object {Object} axboot.gridView
 */
axboot.gridView = {
    name: 'grid',
    page: {
        //pageNumber : 0,
        pageSize: axboot.def.defaultPageSize
    },
    setValue: function setValue(_dindex, _key, _value) {
        this.target.setValue(_dindex, _key, _value);

        axboot.util.bindingTarget(this.target.$target, this.getSelectedData());
    },
    setData: function setData(_data) {
        this.target.setData(_data);
    },
    getData: function getData(_type) {
        var list = [];
        var _list = this.target.getList(_type);
        if (_type == 'modified' || _type == 'deleted') {
            list = ax5.util.filter(_list, function () {
                return true;
            });
        } else {
            list = _list;
        }
        return list;
    },
    getSelectedData: function getSelectedData() {
        return this.getData()[this.getSelectedIndex()];
    },
    getSelectedValue: function getSelectedValue(_key) {
        return this.getSelectedData()[_key];
    },
    setSelectedValue: function setSelectedValue(_key, _value) {
        var selectedIndex = this.getSelectedIndex();

        if (!ax5.util.isNothing(selectedIndex)) {
            this.setValue(selectedIndex, _key, _value);
        }
    },
    getSelectedIndex: function getSelectedIndex() {
        return this.target.selectedDataIndexs[this.target.selectedDataIndexs.length - 1];
    },
    getSelectedIndexs: function getSelectedIndexs() {
        return this.target.selectedDataIndexs;
    },
    isSelected: function isSelected() {
        return this.target.selectedDataIndexs.length > 0;
    },
    addRow: function addRow(_data, _dindex, _options) {
        var selectedIndex = -1;
        var defaultData = $.extend({}, _data, { __created__: true });

        /* 2019.12.06 (이상훈) : 0 번 행으로 입력행 추가시 입력행으로 인식하지 못하는 오류로 인한 처리 */
        if (_dindex === 0) {
            defaultData['__modified__'] = true;
        }

        if (ax5.util.isString(_dindex) || ax5.util.isNumber(_dindex)) {
            selectedIndex = _dindex;

            this.target.addRow(defaultData, _dindex, _options);
            this.target.select(_dindex, { selectedClear: true, selected: true });
        } else {
            selectedIndex = this.target.list.length;

            this.target.addRow(defaultData, 'last', { focus: 'END' });
            this.target.select(selectedIndex, { selectedClear: true, selected: true });
        }

        axboot.util.bindingTarget(this.target.$target, this.getSelectedData());
    },
    updateRow: function updateRow(_data, _dindex) {
        var selectedIndex = -1;
        var defaultData = $.extend({}, _data, { __modified__: true });

        this.target.updateRow(_data, _dindex);
    },
    delRow: function delRow(_type) {
        this.target.deleteRow(_type);
    },
    align: function align() {
        this.target.align();
    },
    clear: function clear() {
        this.target.setData({
            list: [],
            page: {
                currentPage: 0,
                pageSize: 0,
                totalElements: 0,
                totalPages: 0
            }
        });
    },
    setPageData: function setPageData(_page) {
        this.page = $.extend(this.page, _page);
    },
    getPageData: function getPageData() {
        var sortInfos = this.target.sortInfo;

        var sortParams = new Array();
        var sortParamMap = {};
        var sortParam = {};

        for (var key in sortInfos) {
            sortParamMap = {};
            sortParamMap['columnNm'] = key;

            for (var subKey in sortInfos[key]) {
                if (subKey == 'seq') {
                    sortParamMap['columnSeq'] = sortInfos[key][subKey];
                } else if (subKey == 'orderBy') {
                    sortParamMap['orderBy'] = sortInfos[key][subKey];
                }
            }

            sortParams.push(sortParamMap);
        }

        /*
        sortParams.sort(function(a, b) {
            return b['columnSeq'] - a['columnSeq'];
        });
        */

        sortParam['sortInfo'] = sortParams.reverse();

        return $.extend({}, this.page, sortParam);
    },
    setPageNo: function setPageNo(pageNo) {
        this.setPageData({ 'currentPage': pageNo });
    },
    select: function select(rowIndex, options) {
        if (ax5.util.isNothing(options)) {
            options = { selectedClear: true };
        }

        this.target.select(rowIndex, options);
    },
    selectAll: function selectAll(selected) {
        if (selected === undefined) {
            selected = true;
        }

        this.target.selectAll({ selected: selected });
    }
};

/**
 * searchView
 * @Object {Object} axboot.searchView
 */
axboot.searchView = {
    getData: function getData() {
        return axboot.util.getFormToParam(this.target);
    },
    setData: function setData(_obj) {
        for (var k in _obj) {
            if (k in this) {
                this[k].val(_obj[k]);
            }
        }
    },
    getCheckedValue: function getCheckedValue($inp) {
        if ($inp[0].type == "radio") {
            return $inp.filter(":checked").val();
        } else if ($inp[0].type == "checkbox") {
            return function (_$inp) {
                var vals = [];
                _$inp.filter(":checked").each(function () {
                    vals.push(this.value);
                });
                return vals.join(',');
            }.call(this, $inp);
        }
    }
};
axboot.tabView = {
    getTabIndex: function getTabIndex() {
        return this.getActiveTab().panelIndex;
    },
    getActiveTab: function getActiveTab() {
        return axboot.util.getActiveTab(this.target.ax5layout('getActiveTab'));
    },
    setOpenTab: function setOpenTab(tabIndex) {
        this.target.ax5layout('tabOpen', tabIndex);
    }
    /**
     * treeView
     * @Object {Object} axboot.treeView
     */
};axboot.treeView = {};

/**
 * AXBoot uploader
 */
axboot.uploaderView = {
    uploadedFiles: function uploadedFiles() {
        return this.target.uploadedFiles;
    },
    removeFileAll: function removeFileAll() {
        this.target.removeFileAll();
    },
    clear: function clear() {
        this.target.clear();
        //this.target.loadUploaded();

        if (this.target.hasOwnProperty('uploadedGridBox') && !ax5.util.isNothing(this.target.uploadedGridBox)) {
            this.target.uploadedGridBox.setData({
                list: [],
                page: {
                    currentPage: 0,
                    pageSize: 0,
                    totalElements: 0,
                    totalPages: 0
                }
            });
        }
    },
    getStorageId: function getStorageId() {
        return this.target.getStorageId();
    },
    getAttachId: function getAttachId() {
        return this.target.getAttachId();
    },
    setAttachId: function setAttachId(attachId) {
        this.clear();

        if (this.target.getAttachId() != attachId) {
            this.target.setAttachId(attachId);
        }

        if (!ax5.util.isNothing(attachId)) {
            this.target.loadUploaded();
        }
    },
    setUploadedFiles: function setUploadedFiles(data) {
        this.target.setUploadedFiles(data);
    },
    setParams: function setParams(param) {
        this.target.setParams(param);
    }
};